<template>
  <b-container id="resizible-wrapper" class="playlist-container px-0 ml-0 w-100 mw-100 mx-100 position-relative" :class="{ 'res-playlist': this.resPlaylist }" @mouseup="endDragging()">
    <Spinner v-if="loadingStatus" text="Retrieving data..." classes="text-dark-8 mh-60" spinner-color="var(--c-dark-8)"
      spinner-size="15px" />
    <main v-else-if="!hasPlaylist">
      <header class="d-flex align-items-center mb-3 mt-5">
        <h1 ref="title" class="page-title m-0">
          Playlists
        </h1>
      </header>
      <section class="text-center mt-200">
        <h2 class="text-s-m text-dark-9 text-500 mb-2">Craft Your Perfect Playlist with Ease</h2>
        <p class="text-s-s text-dark-8 text-normal col-lg-4 mx-auto mb-2">Drag, drop, and share your playlist!</p>
        <a class="text-dark-8 text-s-ss text-500 mb-4 inline-flex items-center"
          href="https://docs.castr.com/en/articles/8181381-create-playlist-for-your-contents" target="_blank">
          <svg class="mr-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M1.4999 1.8999C1.16853 1.8999 0.899902 2.16853 0.899902 2.4999V12.4999C0.899902 12.8313 1.16853 13.0999 1.4999 13.0999H5.7499C6.66117 13.0999 7.3999 13.8386 7.3999 14.7499V14.9999C7.3999 15.3313 7.66853 15.5999 7.9999 15.5999C8.04132 15.5999 8.08176 15.5957 8.12082 15.5877C8.39423 15.5318 8.5999 15.2899 8.5999 14.9999V14.7499C8.5999 13.8386 9.33863 13.0999 10.2499 13.0999H14.4999C14.8313 13.0999 15.0999 12.8313 15.0999 12.4999V2.4999C15.0999 2.16853 14.8313 1.8999 14.4999 1.8999H10.4999C9.47379 1.8999 8.56413 2.39844 7.9999 3.16652C7.43568 2.39844 6.52601 1.8999 5.4999 1.8999H1.4999ZM8.5999 4.9999L8.5999 12.4258C9.06554 12.0947 9.63498 11.8999 10.2499 11.8999H13.8999V3.0999H10.4999C9.45056 3.0999 8.5999 3.95056 8.5999 4.9999ZM7.3999 4.9999C7.3999 3.95056 6.54924 3.0999 5.4999 3.0999H2.0999V11.8999H5.7499C6.36483 11.8999 6.93426 12.0947 7.3999 12.4258V4.9999Z"
              fill="#ADB8DC" fill-opacity="0.5" />
          </svg>
          How Playlist works
        </a>
        <div class="d-flex flex-column mw-200 mx-auto">
          <b-button class="mb-2 flex items-center" target="_blank" variant="outline-secondary" v-b-modal.modal-demo-video>
            <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M9 2.8999C8.66863 2.8999 8.4 3.16853 8.4 3.4999C8.4 3.83127 8.66863 4.0999 9 4.0999H14.5C14.8314 4.0999 15.1 3.83127 15.1 3.4999C15.1 3.16853 14.8314 2.8999 14.5 2.8999H9ZM9 7.3999C8.66863 7.3999 8.4 7.66853 8.4 7.9999C8.4 8.33127 8.66863 8.5999 9 8.5999H14.5C14.8314 8.5999 15.1 8.33127 15.1 7.9999C15.1 7.66853 14.8314 7.3999 14.5 7.3999H9ZM2 11.8999C1.66863 11.8999 1.4 12.1685 1.4 12.4999C1.4 12.8313 1.66863 13.0999 2 13.0999H14.5C14.8314 13.0999 15.1 12.8313 15.1 12.4999C15.1 12.1685 14.8314 11.8999 14.5 11.8999H2ZM1 3.80567V8.19412C1 8.77296 1.62791 9.13362 2.12791 8.84195L5.88943 6.64771C6.38556 6.3583 6.38555 5.64145 5.88942 5.35204L2.1279 3.15784C1.62791 2.86618 1 3.22683 1 3.80567Z"
                fill="#8794B5" />
            </svg>
            Playlist Demo
          </b-button>
          <b-button size="md" variant="primary" v-b-modal="'modal-add-playlist'" v-if="hasLiveSubscription">
            <svg class="mr-2" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M5.99999 0.399902C6.33136 0.399902 6.59999 0.668532 6.59999 0.999902V5.3999H11C11.3314 5.3999 11.6 5.66853 11.6 5.9999C11.6 6.33127 11.3314 6.5999 11 6.5999H6.59999V10.9999C6.59999 11.3313 6.33136 11.5999 5.99999 11.5999C5.66862 11.5999 5.39999 11.3313 5.39999 10.9999V6.5999H0.999994C0.668623 6.5999 0.399994 6.33127 0.399994 5.9999C0.399994 5.66853 0.668623 5.3999 0.999994 5.3999H5.39999V0.999902C5.39999 0.668532 5.66862 0.399902 5.99999 0.399902Z"
                fill="currentColor" />
            </svg>
            Create Playlist
          </b-button>
          <a href="/app/subscribe" v-else>
            <b-button size="md" variant="primary">
              Upgrade
            </b-button>
          </a>
        </div>
      </section>
    </main>
    <main v-else>
      <div class="playlist-list d-flex align-items-stretch justify-content-between w-100">
        <div class="playlist_left container-mw_mobile-100" :class="{ 'first-step': (this.resStep == 1) }" :style="{width: `${dividerPosition}%`, 'flex-basis': `${dividerPosition}%`}">
          <div class="playlist_header d-flex justify-content-between align-items-center pl-2 mb-4">
            <h2 ref="title" class="text-s-m text-500 m-0">
              Playlist
            </h2>
            <b-button class="pr-1 desk-block" variant="transparent" v-b-modal="'modal-add-playlist'">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M5.0999 2.2499C5.0999 1.91853 4.83127 1.6499 4.4999 1.6499C4.16853 1.6499 3.8999 1.91853 3.8999 2.2499V3.9499C3.8999 4.61264 3.36264 5.1499 2.6999 5.1499H0.999902C0.668532 5.1499 0.399902 5.41853 0.399902 5.7499C0.399902 6.08127 0.668532 6.3499 0.999902 6.3499H2.6999C3.36264 6.3499 3.8999 6.88716 3.8999 7.5499V9.2499C3.8999 9.58127 4.16853 9.8499 4.4999 9.8499C4.83127 9.8499 5.0999 9.58127 5.0999 9.2499V7.5499C5.0999 6.88716 5.63716 6.3499 6.2999 6.3499H7.9999C8.33127 6.3499 8.5999 6.08127 8.5999 5.7499C8.5999 5.41853 8.33127 5.1499 7.9999 5.1499H6.2999C5.63716 5.1499 5.0999 4.61264 5.0999 3.9499V2.2499ZM10.5 2.8999C10.1686 2.8999 9.89999 3.16853 9.89999 3.4999C9.89999 3.83127 10.1686 4.0999 10.5 4.0999H14.4999C14.8313 4.0999 15.0999 3.83127 15.0999 3.4999C15.0999 3.16853 14.8313 2.8999 14.4999 2.8999H10.5ZM10.5 7.3999C10.1686 7.3999 9.89999 7.66853 9.89999 7.9999C9.89999 8.33127 10.1686 8.5999 10.5 8.5999H14.4999C14.8313 8.5999 15.0999 8.33127 15.0999 7.9999C15.0999 7.66853 14.8313 7.3999 14.4999 7.3999H10.5ZM1.99993 11.8999C1.66856 11.8999 1.39993 12.1685 1.39993 12.4999C1.39993 12.8313 1.66856 13.0999 1.99993 13.0999H14.4999C14.8313 13.0999 15.0999 12.8313 15.0999 12.4999C15.0999 12.1685 14.8313 11.8999 14.4999 11.8999H1.99993Z"
                  fill="#68759C" />
              </svg>
            </b-button>
            <b-button class="res-block " size="md" variant="primary" v-b-modal="'modal-add-playlist'">
              <svg class="mr-2" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M5.99999 0.399902C6.33136 0.399902 6.59999 0.668532 6.59999 0.999902V5.3999H11C11.3314 5.3999 11.6 5.66853 11.6 5.9999C11.6 6.33127 11.3314 6.5999 11 6.5999H6.59999V10.9999C6.59999 11.3313 6.33136 11.5999 5.99999 11.5999C5.66862 11.5999 5.39999 11.3313 5.39999 10.9999V6.5999H0.999994C0.668623 6.5999 0.399994 6.33127 0.399994 5.9999C0.399994 5.66853 0.668623 5.3999 0.999994 5.3999H5.39999V0.999902C5.39999 0.668532 5.66862 0.399902 5.99999 0.399902Z"
                  fill="currentColor" />
              </svg>
              New Playlist
            </b-button>
          </div>
          <div class="lists">
            <div class="res-block w-100">
              <div class="w-100 position-relative mb-3">
                <svg class="search_icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                  fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M2.0999 6.7499C2.0999 4.18178 4.18178 2.0999 6.7499 2.0999C9.31803 2.0999 11.3999 4.18178 11.3999 6.7499C11.3999 9.31803 9.31803 11.3999 6.7499 11.3999C4.18178 11.3999 2.0999 9.31803 2.0999 6.7499ZM6.7499 0.899902C3.51904 0.899902 0.899902 3.51904 0.899902 6.7499C0.899902 9.98077 3.51904 12.5999 6.7499 12.5999C8.14923 12.5999 9.4338 12.1086 10.4405 11.2891L14.0756 14.9242C14.31 15.1585 14.6899 15.1585 14.9242 14.9242C15.1585 14.6899 15.1585 14.31 14.9242 14.0756L11.2891 10.4405C12.1086 9.4338 12.5999 8.14923 12.5999 6.7499C12.5999 3.51904 9.98077 0.899902 6.7499 0.899902Z"
                    fill="#8794B5" />
                </svg>
                <b-form-input ref="searchPlaylist" v-model="searchPlaylistInput" placeholder="Search for playlists ..."
                  class="search-form__field liveSearchfield w-100 playlisSearch" @focus="onPlaylistSearchWidgetFocus"
                  @blur="onPlaylistSearchWidgetBlur">
                </b-form-input>
              </div>
              <div class="w-100 playlist_sort d-flex align-items-center justify-content-between px-0">
                <b-dropdown class="" variant="dark-3"
                  toggle-class="p-0 d-flex align-items-center justify-content-between font-weight-normal"
                  menu-class="dropdown-menu_md w-100">
                  <template #button-content>
                    <div class="d-flex align-items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="16" height="16" viewBox="0 0 16 16"
                        fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M1.3999 4.00039C1.3999 3.66902 1.66853 3.40039 1.9999 3.40039H13.9999C14.3313 3.40039 14.5999 3.66902 14.5999 4.00039C14.5999 4.33176 14.3313 4.60039 13.9999 4.60039H1.9999C1.66853 4.60039 1.3999 4.33176 1.3999 4.00039ZM2.8999 8.00039C2.8999 7.66902 3.16853 7.40039 3.4999 7.40039H12.4999C12.8313 7.40039 13.0999 7.66902 13.0999 8.00039C13.0999 8.33176 12.8313 8.60039 12.4999 8.60039H3.4999C3.16853 8.60039 2.8999 8.33176 2.8999 8.00039ZM4.9999 11.4004C4.66853 11.4004 4.3999 11.669 4.3999 12.0004C4.3999 12.3318 4.66853 12.6004 4.9999 12.6004H10.9999C11.3313 12.6004 11.5999 12.3318 11.5999 12.0004C11.5999 11.669 11.3313 11.4004 10.9999 11.4004H4.9999Z"
                          fill="white" />
                      </svg>
                      <span class="text-white text-s-m text-400">{{ sortPlaylistBy }}</span>
                    </div><i class="ml-2 fa fa-chevron-down pl" />
                  </template>
                  <b-dropdown-item class="p-0 m-0" :active="sortPlaylistBy === 'Newest first'"
                    @click="changePlaylistSortBy('Newest first')">
                    <div class="ml-2 p-0 m-0">Newest first</div>
                  </b-dropdown-item>
                  <b-dropdown-item class="p-0 m-0" :active="sortPlaylistBy === 'Oldest first'"
                    @click="changePlaylistSortBy('Oldest first')">
                    <div class="ml-2 p-0 m-0">Oldest first</div>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <ul class="list-group">
              <li
                class="list-group-item px-2 py-2 border-0 d-flex align-items-center justify-content-between text-s-ss font-normal text-dark-8"
                v-for="(list, index) in playlistCopy" :key="index" @click="selectPlaylist(index)"
                :class="{ 'active': (index == playlistIndex) }">
                <span class="flex items-center">
                  <svg class="mr-2 desk-block" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                    viewBox="0 0 16 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M9 2.8999C8.66863 2.8999 8.4 3.16853 8.4 3.4999C8.4 3.83127 8.66863 4.0999 9 4.0999H14.5C14.8314 4.0999 15.1 3.83127 15.1 3.4999C15.1 3.16853 14.8314 2.8999 14.5 2.8999H9ZM9 7.3999C8.66863 7.3999 8.4 7.66853 8.4 7.9999C8.4 8.33127 8.66863 8.5999 9 8.5999H14.5C14.8314 8.5999 15.1 8.33127 15.1 7.9999C15.1 7.66853 14.8314 7.3999 14.5 7.3999H9ZM2 11.8999C1.66863 11.8999 1.4 12.1685 1.4 12.4999C1.4 12.8313 1.66863 13.0999 2 13.0999H14.5C14.8314 13.0999 15.1 12.8313 15.1 12.4999C15.1 12.1685 14.8314 11.8999 14.5 11.8999H2ZM1 3.80567V8.19412C1 8.77296 1.62791 9.13362 2.12791 8.84195L5.88943 6.64771C6.38556 6.3583 6.38555 5.64145 5.88942 5.35204L2.1279 3.15784C1.62791 2.86618 1 3.22683 1 3.80567Z"
                      fill="#8794B5" />
                  </svg>
                  {{ list.name }}
                </span>
                <span class="text-dark-7 desk-block">
                  {{ list.streams.length }}
                </span>
                <span class="text-dark-8 res-block">
                  <svg class="mr-1 res-block" xmlns="http://www.w3.org/2000/svg" width="16" height="17"
                    viewBox="0 0 16 17" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M2 5C2.55228 5 3 4.55228 3 4C3 3.44772 2.55228 3 2 3C1.44772 3 1 3.44772 1 4C1 4.55228 1.44772 5 2 5ZM6 3.4C5.66863 3.4 5.4 3.66863 5.4 4C5.4 4.33137 5.66863 4.6 6 4.6H14.5C14.8314 4.6 15.1 4.33137 15.1 4C15.1 3.66863 14.8314 3.4 14.5 3.4H6ZM6 7.9C5.66863 7.9 5.4 8.16863 5.4 8.5C5.4 8.83137 5.66863 9.1 6 9.1H14.5C14.8314 9.1 15.1 8.83137 15.1 8.5C15.1 8.16863 14.8314 7.9 14.5 7.9H6ZM6 12.4C5.66863 12.4 5.4 12.6686 5.4 13C5.4 13.3314 5.66863 13.6 6 13.6H14.5C14.8314 13.6 15.1 13.3314 15.1 13C15.1 12.6686 14.8314 12.4 14.5 12.4H6ZM3 8.5C3 9.05228 2.55228 9.5 2 9.5C1.44772 9.5 1 9.05228 1 8.5C1 7.94772 1.44772 7.5 2 7.5C2.55228 7.5 3 7.94772 3 8.5ZM2 14C2.55228 14 3 13.5523 3 13C3 12.4477 2.55228 12 2 12C1.44772 12 1 12.4477 1 13C1 13.5523 1.44772 14 2 14Z"
                      fill="#8794B5" />
                  </svg>
                  {{ list.streams.length }} items
                </span>
                <div class="d-inline-flex res-control justify-content-end ml-auto align-items-center res-flex mt-2"
                  v-on:click.stop>
                  <svg @click="removePlaylist(index)" class="mr-3" xmlns="http://www.w3.org/2000/svg" width="16"
                    height="16" viewBox="0 0 16 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M3.25727 3.17078C3.20842 3.20228 3.17316 3.22895 3.14794 3.25039C3.17316 3.27183 3.20842 3.2985 3.25727 3.33C3.46244 3.46229 3.79909 3.60412 4.26869 3.73219C5.19928 3.98599 6.51869 4.15039 7.9999 4.15039C9.48112 4.15039 10.8005 3.98599 11.7311 3.73219C12.2007 3.60412 12.5374 3.46229 12.7425 3.33C12.7914 3.2985 12.8266 3.27183 12.8519 3.25039C12.8266 3.22895 12.7914 3.20228 12.7425 3.17078C12.5374 3.03849 12.2007 2.89666 11.7311 2.76859C10.8005 2.51479 9.48112 2.35039 7.9999 2.35039C6.51869 2.35039 5.19928 2.51479 4.26869 2.76859C3.79909 2.89666 3.46244 3.03849 3.25727 3.17078ZM7.9999 1.15039C6.44355 1.15039 5.01296 1.32178 3.95294 1.61087C3.42724 1.75425 2.95843 1.93564 2.60697 2.16226C2.28238 2.37156 1.8999 2.72554 1.8999 3.25039C1.8999 3.33867 1.91072 3.42212 1.93027 3.50086L2.74308 12.4054C2.79195 12.9407 3.02595 13.56 3.61731 13.9067C4.34647 14.3341 5.70564 14.8504 7.9999 14.8504C10.2942 14.8504 11.6533 14.3341 12.3825 13.9067C12.9738 13.56 13.2078 12.9407 13.2567 12.4054L14.0695 3.50087C14.0891 3.42213 14.0999 3.33868 14.0999 3.25039C14.0999 2.72554 13.7174 2.37156 13.3928 2.16226C13.0414 1.93564 12.5726 1.75425 12.0469 1.61087C10.9868 1.32178 9.55625 1.15039 7.9999 1.15039ZM12.7591 4.65588C12.5393 4.74322 12.2997 4.82096 12.0469 4.88991C10.9868 5.179 9.55625 5.35039 7.9999 5.35039C6.44355 5.35039 5.01296 5.179 3.95294 4.88991C3.70013 4.82096 3.46047 4.74321 3.24069 4.65588L3.93812 12.2963C3.96631 12.6052 4.08418 12.7894 4.22415 12.8714C4.74697 13.1779 5.89154 13.6504 7.9999 13.6504C10.1083 13.6504 11.2528 13.1779 11.7756 12.8714C11.9156 12.7894 12.0335 12.6052 12.0617 12.2963L12.7591 4.65588Z"
                      fill="#68759C" />
                  </svg>
                  <b-button v-b-tooltip.hover variant="outline-secondary" class="text-dark-8" size="sm"
                    title="Enable your stream to start broadcasting" @click="playlistToggle(index)" v-if="list.disabled">
                    Enable
                  </b-button>
                  <b-button variant="outline-secondary" class="text-dark-8 btn_enable" size="sm"
                    @click="playlistToggle(index)" v-else>
                    Disable
                  </b-button>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div
					class="aside-divider"
					:style="{
						left: `${dividerPosition}%`
					}"
					@mousedown="startDragging()"
				>
				</div>
        <div class="playlist_right" :class="{ 'second-step': (this.resStep == 2), 'third-step': (this.resStep == 3) }" :style="{width: `${100 - dividerPosition}%`, 'flex-basis': 100 - `${dividerPosition}%`}">
          <div class="w-100 d-flex justify-content-between align-items-start">
            <div class="all-streams d-flex align-items-start justify-content-between">
              <!-- {{playlist[this.playlistIndex]?.name}} -->
              <div class="playlist-item pt-1" v-if="playlist">
                <div class="d-flex align-items-center justify-content-between">
                  <!-- <p class="text-s-xxl text-500">{{playlist[this.playlistIndex].name}}</p> -->
                  <div class="d-flex align-items-center justify-content-start">
                    <div>
                      <div class="d-flex align-items-center justify-content-start pl-input">
                        <svg @click="showPlaylist()" class="res-block mr-2 mt-1" xmlns="http://www.w3.org/2000/svg"
                          width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M7.60944 2.54484C7.83413 2.35224 8.16569 2.35224 8.39039 2.54484L11.8904 5.54484C12.142 5.76049 12.1711 6.13927 11.9555 6.39087C11.7398 6.64246 11.361 6.6716 11.1094 6.45594L7.99991 3.79064L4.89039 6.45594C4.63879 6.6716 4.26001 6.64246 4.04436 6.39087C3.82871 6.13927 3.85784 5.76049 4.10944 5.54484L7.60944 2.54484ZM4.04436 9.60992C4.26001 9.35832 4.63879 9.32918 4.89039 9.54484L7.99991 12.2101L11.1094 9.54484C11.361 9.32918 11.7398 9.35832 11.9555 9.60992C12.1711 9.86151 12.142 10.2403 11.8904 10.4559L8.39039 13.4559C8.16569 13.6485 7.83413 13.6485 7.60944 13.4559L4.10944 10.4559C3.85784 10.2403 3.82871 9.86151 4.04436 9.60992Z"
                            fill="#68759C" />
                        </svg>
                        <b-input size="sm" class="text-s-xxl text-500 pl-0" v-model="playlistName" @change="changeName" />
                      </div>
                      <a class="desk-block text-dark-6 text-s-ss text-500 mb-0 flex items-center"
                        href="https://docs.castr.com/en/articles/8181381-create-playlist-for-your-contents"
                        target="_blank">
                        <svg class="mr-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                          fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M1.4999 1.8999C1.16853 1.8999 0.899902 2.16853 0.899902 2.4999V12.4999C0.899902 12.8313 1.16853 13.0999 1.4999 13.0999H5.7499C6.66117 13.0999 7.3999 13.8386 7.3999 14.7499V14.9999C7.3999 15.3313 7.66853 15.5999 7.9999 15.5999C8.04132 15.5999 8.08176 15.5957 8.12082 15.5877C8.39423 15.5318 8.5999 15.2899 8.5999 14.9999V14.7499C8.5999 13.8386 9.33863 13.0999 10.2499 13.0999H14.4999C14.8313 13.0999 15.0999 12.8313 15.0999 12.4999V2.4999C15.0999 2.16853 14.8313 1.8999 14.4999 1.8999H10.4999C9.47379 1.8999 8.56413 2.39844 7.9999 3.16652C7.43568 2.39844 6.52601 1.8999 5.4999 1.8999H1.4999ZM8.5999 4.9999L8.5999 12.4258C9.06554 12.0947 9.63498 11.8999 10.2499 11.8999H13.8999V3.0999H10.4999C9.45056 3.0999 8.5999 3.95056 8.5999 4.9999ZM7.3999 4.9999C7.3999 3.95056 6.54924 3.0999 5.4999 3.0999H2.0999V11.8999H5.7499C6.36483 11.8999 6.93426 12.0947 7.3999 12.4258V4.9999Z"
                            fill="#ADB8DC" fill-opacity="0.5" />
                        </svg>
                        How Playlist works
                      </a>
                      <a class="desk-block text-dark-6 text-s-ss text-500 mb-0 flex items-center" v-b-modal.modal-demo-video>
                        <svg class="mr-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                          fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M9 2.8999C8.66863 2.8999 8.4 3.16853 8.4 3.4999C8.4 3.83127 8.66863 4.0999 9 4.0999H14.5C14.8314 4.0999 15.1 3.83127 15.1 3.4999C15.1 3.16853 14.8314 2.8999 14.5 2.8999H9ZM9 7.3999C8.66863 7.3999 8.4 7.66853 8.4 7.9999C8.4 8.33127 8.66863 8.5999 9 8.5999H14.5C14.8314 8.5999 15.1 8.33127 15.1 7.9999C15.1 7.66853 14.8314 7.3999 14.5 7.3999H9ZM2 11.8999C1.66863 11.8999 1.4 12.1685 1.4 12.4999C1.4 12.8313 1.66863 13.0999 2 13.0999H14.5C14.8314 13.0999 15.1 12.8313 15.1 12.4999C15.1 12.1685 14.8314 11.8999 14.5 11.8999H2ZM1 3.80567V8.19412C1 8.77296 1.62791 9.13362 2.12791 8.84195L5.88943 6.64771C6.38556 6.3583 6.38555 5.64145 5.88942 5.35204L2.1279 3.15784C1.62791 2.86618 1 3.22683 1 3.80567Z"
                            fill="#8794B5" />
                        </svg>
                        Playlist Demo
                      </a>
                    </div>
                  </div>
                  <div class="playlist-top-control">
                    <b-button variant="outline-secondary" class="text-dark-8 btn_enable mr-2" size="sm"
                      @click="playlistToggle()">
                      <span class="text-dark-8 text-s-s text-500"> {{
                        this.playlistCopy[this.playlistIndex].disabled ? 'Enable' :
                        'Disable' }}</span>
                    </b-button>
                    <b-dropdown menu-class="dropdown-menu_md teamlist-option p-0" right no-caret variant="icon" size="sm"
                      toggle-class="pr-1 pl-1" class="">
                      <template #button-content>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M4 8C4 8.69036 3.44036 9.25 2.75 9.25C2.05964 9.25 1.5 8.69036 1.5 8C1.5 7.30964 2.05964 6.75 2.75 6.75C3.44036 6.75 4 7.30964 4 8ZM9.25 8C9.25 8.69036 8.69036 9.25 8 9.25C7.30964 9.25 6.75 8.69036 6.75 8C6.75 7.30964 7.30964 6.75 8 6.75C8.69036 6.75 9.25 7.30964 9.25 8ZM13.25 9.25C13.9404 9.25 14.5 8.69036 14.5 8C14.5 7.30964 13.9404 6.75 13.25 6.75C12.5596 6.75 12 7.30964 12 8C12 8.69036 12.5596 9.25 13.25 9.25Z"
                            fill="#68759C" />
                        </svg>
                      </template>
                      <b-dropdown-item variant="delete" class="p-0" @click="removePlaylist()">
                        <span class="text-white">Delete</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
                <b-button size="md" variant="primary" class="mt-2 res-block w-100 addPlaylist_btn"
                  @click="openStreamslist()" v-if="playlist[this.playlistIndex].streams.length != 0">
                  <svg class="mr-2" width="12" height="12" viewBox="0 0 12 12" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M5.99999 0.399902C6.33136 0.399902 6.59999 0.668532 6.59999 0.999902V5.3999H11C11.3314 5.3999 11.6 5.66853 11.6 5.9999C11.6 6.33127 11.3314 6.5999 11 6.5999H6.59999V10.9999C6.59999 11.3313 6.33136 11.5999 5.99999 11.5999C5.66862 11.5999 5.39999 11.3313 5.39999 10.9999V6.5999H0.999994C0.668623 6.5999 0.399994 6.33127 0.399994 5.9999C0.399994 5.66853 0.668623 5.3999 0.999994 5.3999H5.39999V0.999902C5.39999 0.668532 5.66862 0.399902 5.99999 0.399902Z"
                      fill="currentColor" />
                  </svg>
                  Add Content
                </b-button>
                <b-row v-if="!hasLiveSubscription || isLiveSubscriptionExpired">
                  <b-col lg="12">
                    <b-alert variant="danger" show class="d-flex align-items-start">
                      <svg class="mr-2 flex-shrink-0" width="16" height="16" viewBox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M4.57328 3.12854C5.18596 2.51587 5.38162 2.33522 5.61326 2.23928C5.8449 2.14333 6.11099 2.13271 6.97745 2.13271L9.02131 2.13271C9.88776 2.13271 10.1538 2.14333 10.3855 2.23928C10.6171 2.33522 10.8128 2.51587 11.4255 3.12854L12.8707 4.57377C13.4834 5.18645 13.664 5.38211 13.76 5.61375C13.8559 5.84539 13.8665 6.11148 13.8665 6.97793V9.0218C13.8665 9.88825 13.8559 10.1543 13.76 10.386C13.664 10.6176 13.4834 10.8133 12.8707 11.426L11.4255 12.8712C10.8128 13.4839 10.6171 13.6645 10.3855 13.7605C10.1538 13.8564 9.88776 13.867 9.02131 13.867L6.97744 13.867C6.11099 13.867 5.8449 13.8564 5.61326 13.7605C5.38162 13.6645 5.18596 13.4839 4.57328 12.8712L3.12806 11.426C2.51538 10.8133 2.33474 10.6176 2.23879 10.386C2.14284 10.1543 2.13222 9.88825 2.13222 9.02179L2.13222 6.97793C2.13222 6.11148 2.14284 5.84539 2.23879 5.61375C2.33474 5.38211 2.51538 5.18645 3.12806 4.57377L4.57328 3.12854ZM5.15404 1.13062C4.67417 1.32939 4.30427 1.69977 3.80006 2.20465L3.72476 2.28002L2.27953 3.72524L2.20416 3.80054C1.69929 4.30476 1.3289 4.67466 1.13013 5.15453C0.931362 5.6344 0.931706 6.15786 0.932173 6.8714L0.93222 6.97793V9.02179L0.932173 9.12833C0.931706 9.84186 0.931362 10.3653 1.13013 10.8452C1.3289 11.3251 1.69929 11.695 2.20417 12.1992L2.27953 12.2745L3.72476 13.7197L3.80005 13.7951C4.30427 14.3 4.67417 14.6703 5.15404 14.8691C5.63392 15.0679 6.15738 15.0675 6.87092 15.0671L6.97744 15.067H9.0213L9.12785 15.0671C9.84138 15.0675 10.3648 15.0679 10.8447 14.8691C11.3246 14.6703 11.6945 14.3 12.1987 13.7951L12.274 13.7197L13.7192 12.2745L13.7946 12.1992L13.7946 12.1992C14.2995 11.695 14.6698 11.3251 14.8686 10.8452C15.0674 10.3653 15.067 9.84187 15.0666 9.12834V9.12832L15.0665 9.0218V6.97793L15.0666 6.8714C15.067 6.15786 15.0674 5.6344 14.8686 5.15453C14.6698 4.67466 14.2995 4.30476 13.7946 3.80054L13.7192 3.72524L12.274 2.28002L12.1987 2.20465L12.1987 2.20464C11.6945 1.69977 11.3246 1.32939 10.8447 1.13062C10.3648 0.931851 9.84138 0.932194 9.12784 0.932662L9.02131 0.932708H6.97745L6.87091 0.932662C6.15737 0.932194 5.63392 0.931851 5.15404 1.13062ZM6.67465 5.82559C6.44034 5.59127 6.06044 5.59126 5.82612 5.82557C5.5918 6.05987 5.59178 6.43977 5.82609 6.67409L7.15175 7.99984L5.82609 9.32559C5.59178 9.55992 5.5918 9.93982 5.82612 10.1741C6.06044 10.4084 6.44034 10.4084 6.67465 10.1741L8.00028 8.84837L9.32612 10.1741C9.56044 10.4084 9.94034 10.4084 10.1746 10.1741C10.409 9.93977 10.4089 9.55987 10.1746 9.32557L8.8488 7.99984L10.1746 6.67412C10.4089 6.43982 10.409 6.05992 10.1746 5.82559C9.94034 5.59127 9.56044 5.59126 9.32612 5.82557L8.00028 7.15132L6.67465 5.82559Z"
                          fill="white" />
                      </svg>
                      <p class="text-s-ss mb-0">Your plan has ended. Please <a class="text-underline text-reset"
                          target="_blank" href="/app/subscribe">upgrade</a> to continue.</p>
                    </b-alert>
                  </b-col>
                </b-row>
                <div class="playlist">
                  <div class="uploader-body">
                    <div class="d-flex mb-4 flex-wrap align-items-start justify-content-start">
                      <div class="w-100" @click.stop.prevent="log('clicked!', $event)" @dragover="dragover"
                        @dragleave="dragleave" @drop="drop">
                        <input ref="uploadInputDrop" type="file" :multiple="allowMultipleUploads" style="display: none;"
                          accept="video/mp4" name="fields[assetsFieldHandle][]" id="assetsFieldHandleDrop"
                          @change="onChange($event)">
                        <label for="assetsFieldHandleDrop" class="d-flex w-100">
                          <div
                            class="rounded-circle drop-zone-circle drop-zone-circle_hovered d-flex flex-column align-items-center justify-content-center"
                            v-if="playlistCopy[this.playlistIndex].streams.length === 0">
                            <div class="text-center px-5">
                              <svg class="mb-4 d-inline-block" width="48" height="48" viewBox="0 0 48 48" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M34.6 45.5H14.4C13.2716 45.5 12.4554 45.4996 11.8135 45.4472C11.1774 45.3952 10.7566 45.2946 10.411 45.1185C9.75247 44.783 9.21703 44.2475 8.88148 43.589C8.70539 43.2434 8.60481 42.8226 8.55284 42.1865C8.50039 41.5446 8.5 40.7284 8.5 39.6V8.4C8.5 7.27165 8.50039 6.45545 8.55284 5.81352C8.60481 5.17744 8.70539 4.75662 8.88148 4.41103C9.21703 3.75247 9.75247 3.21703 10.411 2.88148C10.7566 2.70539 11.1774 2.60481 11.8135 2.55284C12.4554 2.50039 13.2716 2.5 14.4 2.5H31.7929L40.5 11.2071V39.6C40.5 40.7284 40.4996 41.5446 40.4472 42.1865C40.3952 42.8226 40.2946 43.2434 40.1185 43.589C39.783 44.2475 39.2475 44.783 38.589 45.1185C38.2434 45.2946 37.8226 45.3952 37.1865 45.4472C36.5446 45.4996 35.7284 45.5 34.6 45.5Z"
                                  fill="#232D4D" stroke="#343E61" />
                                <path d="M25 33V23M25 23L21 27M25 23L29 27" stroke="#404B72" stroke-width="1.5"
                                  stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                  d="M32 2L41 11C41 11.5523 40.5523 12 40 12H35.2857C34.0888 12 33.4903 12 33.0092 11.8316C32.1474 11.5301 31.4699 10.8526 31.1683 9.99084C31 9.50972 31 8.91124 31 7.71429V3C31 2.44772 31.4477 2 32 2Z"
                                  fill="#343E61" />
                              </svg>
                              <p class="text-s-m text-dark-9 mb-1">Here’s no content yet</p>
                              <p class="text-s-s text-dark-6 mb-0">Add streams and VOD files
                                by drag & dropping from the existing ones on the right.</p>
                              <b-button size="md" variant="primary" class="mt-3 res-block" @click="openStreamslist()">
                                <svg class="mr-2" width="12" height="12" viewBox="0 0 12 12" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M5.99999 0.399902C6.33136 0.399902 6.59999 0.668532 6.59999 0.999902V5.3999H11C11.3314 5.3999 11.6 5.66853 11.6 5.9999C11.6 6.33127 11.3314 6.5999 11 6.5999H6.59999V10.9999C6.59999 11.3313 6.33136 11.5999 5.99999 11.5999C5.66862 11.5999 5.39999 11.3313 5.39999 10.9999V6.5999H0.999994C0.668623 6.5999 0.399994 6.33127 0.399994 5.9999C0.399994 5.66853 0.668623 5.3999 0.999994 5.3999H5.39999V0.999902C5.39999 0.668532 5.66862 0.399902 5.99999 0.399902Z"
                                    fill="currentColor" />
                                </svg>
                                Add Content
                              </b-button>
                            </div>
                          </div>
                          <div class="drop-zone-circle border-0" v-else>
                            <ul class="p-0">
                              <li class="text-dark-6 text-500 text-s-ss pl-0">Content</li>
                              <draggable v-model="streamsModal" tag="div" :item-key="(item) => item._id" @change="changedOrder(streamsModal)">
                                <template #item="{ element }">
                                  <li class="d-flex align-items-center justify-content-between pr-0"
                                  >
                                  <div class="d-flex align-items-center justify-content-between">
                                    <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                      viewBox="0 0 16 16" fill="none">
                                      <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M5.5 4.5C6.05228 4.5 6.5 4.05228 6.5 3.5C6.5 2.94772 6.05228 2.5 5.5 2.5C4.94772 2.5 4.5 2.94772 4.5 3.5C4.5 4.05228 4.94772 4.5 5.5 4.5ZM10.5 4.5C11.0523 4.5 11.5 4.05228 11.5 3.5C11.5 2.94772 11.0523 2.5 10.5 2.5C9.94772 2.5 9.5 2.94772 9.5 3.5C9.5 4.05228 9.94772 4.5 10.5 4.5ZM6.5 8C6.5 8.55228 6.05228 9 5.5 9C4.94772 9 4.5 8.55228 4.5 8C4.5 7.44772 4.94772 7 5.5 7C6.05228 7 6.5 7.44772 6.5 8ZM10.5 9C11.0523 9 11.5 8.55228 11.5 8C11.5 7.44772 11.0523 7 10.5 7C9.94772 7 9.5 7.44772 9.5 8C9.5 8.55228 9.94772 9 10.5 9ZM6.5 12.5C6.5 13.0523 6.05228 13.5 5.5 13.5C4.94772 13.5 4.5 13.0523 4.5 12.5C4.5 11.9477 4.94772 11.5 5.5 11.5C6.05228 11.5 6.5 11.9477 6.5 12.5ZM10.5 13.5C11.0523 13.5 11.5 13.0523 11.5 12.5C11.5 11.9477 11.0523 11.5 10.5 11.5C9.94772 11.5 9.5 11.9477 9.5 12.5C9.5 13.0523 9.94772 13.5 10.5 13.5Z"
                                        fill="#8794B5" />
                                    </svg>
                                    <div class="single-stream flex items-center">
                                      <svg v-if="(element.type == 'live')" class="mr-3" xmlns="http://www.w3.org/2000/svg"
                                        width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M4.99998 2.75H4.98853C4.29815 2.75 3.76469 2.75 3.33762 2.78489C2.90528 2.82021 2.56001 2.89254 2.2515 3.04973C1.73406 3.31338 1.31336 3.73408 1.04971 4.25153C0.892517 4.56003 0.820191 4.90531 0.784868 5.33765C0.749977 5.76471 0.749977 6.29817 0.749977 6.98856V7V9V9.01144C0.749977 9.70183 0.749977 10.2353 0.784868 10.6624C0.820191 11.0947 0.892517 11.44 1.04971 11.7485C1.31336 12.2659 1.73406 12.6866 2.2515 12.9503C2.56001 13.1075 2.90528 13.1798 3.33762 13.2151C3.76468 13.25 4.29812 13.25 4.98849 13.25H4.9885H4.98851H4.98853H4.99998H6.99998H7.01143H7.01144H7.01145H7.01147C7.70183 13.25 8.23527 13.25 8.66233 13.2151C9.09467 13.1798 9.43994 13.1075 9.74845 12.9503C10.2659 12.6866 10.6866 12.2659 10.9502 11.7485C11.1074 11.44 11.1798 11.0947 11.2151 10.6624C11.2422 10.3306 11.2482 9.93465 11.2496 9.45081L14.1025 11.2339C14.602 11.5461 15.25 11.1869 15.25 10.5979V5.40212C15.25 4.81304 14.602 4.45391 14.1025 4.76612L11.2496 6.54917C11.2482 6.06534 11.2422 5.66939 11.2151 5.33765C11.1798 4.90531 11.1074 4.56003 10.9502 4.25153C10.6866 3.73408 10.2659 3.31338 9.74845 3.04973C9.43994 2.89254 9.09467 2.82021 8.66233 2.78489C8.23526 2.75 7.70181 2.75 7.01142 2.75H6.99998H4.99998Z"
                                          fill="#AEBAD6" />
                                      </svg>
                                      <svg v-else class="mr-3" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                        viewBox="0 0 16 16" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M5.49996 1.3999H5.47417C5.14271 1.3999 4.84296 1.3999 4.57156 1.40411C4.54815 1.40133 4.52432 1.3999 4.50017 1.3999C4.46797 1.3999 4.43636 1.40244 4.40553 1.40732C4.18796 1.41247 3.98981 1.42119 3.8091 1.43596C3.35511 1.47305 2.95864 1.55126 2.59257 1.73779C2.00926 2.035 1.53502 2.50924 1.23782 3.09255C1.0513 3.45863 0.973088 3.85509 0.936001 4.30908C0.899941 4.75048 0.899951 5.29596 0.899964 5.97415L0.899964 5.99995L0.900005 9.99995L0.900005 10.0257C0.900006 10.7039 0.900007 11.2494 0.936075 11.6908C0.973171 12.1448 1.05139 12.5412 1.23791 12.9073C1.53512 13.4906 2.00936 13.9648 2.59266 14.262C2.95873 14.4485 3.35518 14.5268 3.80917 14.5639C3.98986 14.5786 4.18799 14.5873 4.40552 14.5925C4.43635 14.5974 4.46796 14.5999 4.50017 14.5999C4.52433 14.5999 4.54815 14.5985 4.57156 14.5957C4.84297 14.5999 5.14274 14.5999 5.4742 14.5999H5.47421H5.47422H5.5H10.5H10.5258H10.5258H10.5258H10.5259C10.8574 14.5999 11.1573 14.5999 11.4287 14.5957C11.4522 14.5985 11.476 14.5999 11.5002 14.5999C11.5324 14.5999 11.564 14.5974 11.5949 14.5925C11.8123 14.5873 12.0103 14.5786 12.1909 14.5638C12.6449 14.5268 13.0413 14.4485 13.4074 14.262C13.9907 13.9648 14.4649 13.4906 14.7622 12.9073C14.9487 12.5412 15.0269 12.1447 15.064 11.6907C15.1 11.2493 15.1 10.7039 15.1 10.0257V10.0257V9.99986L15.1 9.51917C15.1002 9.51278 15.1003 9.50635 15.1003 9.49991C15.1003 9.49346 15.1002 9.48703 15.1 9.48063L15.1 5.99986V5.97409C15.1 5.2959 15.1 4.75042 15.0639 4.30902C15.0268 3.85504 14.9486 3.45858 14.7621 3.09251C14.4648 2.50922 13.9906 2.03498 13.4073 1.73778C13.0412 1.55126 12.6448 1.47305 12.1908 1.43596C12.0102 1.4212 11.8122 1.41249 11.5949 1.40734C11.564 1.40244 11.5324 1.3999 11.5002 1.3999C11.476 1.3999 11.4522 1.40133 11.4287 1.40411C11.1572 1.3999 10.8574 1.3999 10.5258 1.3999H10.5H5.49996ZM3.13736 2.80699C3.30508 2.72153 3.52445 2.66368 3.90017 2.63252V5.14991H2.10318C2.10689 4.85885 2.11487 4.61668 2.13202 4.40679C2.16304 4.02701 2.22107 3.80604 2.30703 3.63733C2.48919 3.27982 2.77985 2.98915 3.13736 2.80699ZM2.09997 6.34991L2.09999 8.89991H3.90017V6.34991H2.09997ZM5.10017 2.6002V8.89991H10.9002V2.6002C10.7747 2.59992 10.6416 2.5999 10.5 2.5999H5.49996C5.35849 2.5999 5.2255 2.59992 5.10017 2.6002ZM2.10001 10.0999H3.90017V13.3673C3.5245 13.3361 3.30515 13.2783 3.13744 13.1928C2.77994 13.0107 2.48927 12.72 2.30711 12.3625C2.22115 12.1938 2.16312 11.9728 2.13209 11.5931C2.10199 11.2247 2.10013 10.7569 2.10001 10.0999ZM5.10017 10.0999V13.3996C5.22551 13.3999 5.35852 13.3999 5.5 13.3999H10.5C10.6416 13.3999 10.7747 13.3999 10.9002 13.3996V10.0999H5.10017ZM12.8626 13.1928C12.6949 13.2782 12.4757 13.3361 12.1002 13.3673V10.0999H13.9C13.8999 10.7569 13.898 11.2247 13.868 11.593C13.8369 11.9728 13.7789 12.1938 13.6929 12.3625C13.5108 12.72 13.2201 13.0107 12.8626 13.1928ZM13.9 8.89991H12.1002V6.34991H13.9L13.9 8.89991ZM13.8967 5.14991H12.1002V2.63255C12.4756 2.66372 12.6949 2.72156 12.8625 2.80699C13.22 2.98914 13.5107 3.2798 13.6929 3.63731C13.7788 3.80602 13.8368 4.02698 13.8679 4.40675C13.885 4.61665 13.893 4.85883 13.8967 5.14991Z"
                                          fill="#AEBAD6" />
                                      </svg>
                                      <span class="text-normal text-s-ss text-dark-9" v-if="element.name">{{
                                        (element.name.length >
                                          22) ? element.name.substring(0, 22) + ".." :
                                          element.name }}</span>

                                      <!-- <span class="text-normal text-s-ss text-dark-9" v-else>{{ stream }}</span> -->
                                    </div>
                                  </div>
                                  <svg @click="removeItem(element)" xmlns="http://www.w3.org/2000/svg" width="16"
                                    height="16" viewBox="0 0 16 16" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M3.07564 3.07613C3.30995 2.84181 3.68985 2.84181 3.92417 3.07613L7.9999 7.15186L12.0756 3.07613C12.31 2.84181 12.6899 2.84181 12.9242 3.07613C13.1585 3.31044 13.1585 3.69034 12.9242 3.92465L8.84843 8.00039L12.9242 12.0761C13.1585 12.3104 13.1585 12.6903 12.9242 12.9247C12.6899 13.159 12.31 13.159 12.0756 12.9247L7.9999 8.84892L3.92417 12.9247C3.68985 13.159 3.30995 13.159 3.07564 12.9247C2.84132 12.6903 2.84132 12.3104 3.07564 12.0761L7.15137 8.00039L3.07564 3.92465C2.84132 3.69034 2.84132 3.31044 3.07564 3.07613Z"
                                      fill="#68759C" />
                                  </svg>
                                </li>
                                </template>
                              </draggable>
                            </ul>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <b-tabs class="tabs-light playlist-source mt-0" nav-class="tabs-light-border"
                :class="{ 'second-step': (this.resStep == 2), 'third-step': (this.resStep == 3) }">
                <div class="tab-close res-block" @click="backOnestep()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M8 8L13 3M8 8L13 13M8 8L3 3M8 8L3 13" stroke="#AEBAD6" stroke-width="1.5"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <b-tab @click="changeRouteQuery('live')" title="Livestream" class="sltremsCat"
                  :active="this.$route.query && this.$route.query.tab === 'live'">
                  <ul>
                    <li>
                      <svg class="search_icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        viewBox="0 0 16 16" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M2.0999 6.7499C2.0999 4.18178 4.18178 2.0999 6.7499 2.0999C9.31803 2.0999 11.3999 4.18178 11.3999 6.7499C11.3999 9.31803 9.31803 11.3999 6.7499 11.3999C4.18178 11.3999 2.0999 9.31803 2.0999 6.7499ZM6.7499 0.899902C3.51904 0.899902 0.899902 3.51904 0.899902 6.7499C0.899902 9.98077 3.51904 12.5999 6.7499 12.5999C8.14923 12.5999 9.4338 12.1086 10.4405 11.2891L14.0756 14.9242C14.31 15.1585 14.6899 15.1585 14.9242 14.9242C15.1585 14.6899 15.1585 14.31 14.9242 14.0756L11.2891 10.4405C12.1086 9.4338 12.5999 8.14923 12.5999 6.7499C12.5999 3.51904 9.98077 0.899902 6.7499 0.899902Z"
                          fill="#8794B5" />
                      </svg>
                      <b-form-input ref="searchLive" v-model="searchLiveInput" placeholder="Search ..."
                        class="search-form__field liveSearchfield" @focus="onSearchWidgetFocus"
                        @blur="onSearchWidgetBlur">
                      </b-form-input>
                    </li>
                    <li class="d-flex align-items-center justify-content-between px-0">
                      <span class="text-dark-6 text-s-ss text-normal p-0">{{ allInOneStreams.length }}
                        streams</span>
                      <b-dropdown class="" variant="transparent" no-caret
                        toggle-class="p-0 d-flex align-items-center justify-content-between font-weight-normal"
                        menu-class="dropdown-menu_md">
                        <template #button-content>
                          <div class="d-flex align-items-center">
                            <span class="ml-1 text-dark-8 text-s-ss text-500">{{ sortBy
                            }}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                              fill="none">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M7.60944 2.54435C7.83413 2.35175 8.16569 2.35175 8.39039 2.54435L11.8904 5.54435C12.142 5.76 12.1711 6.13878 11.9555 6.39038C11.7398 6.64197 11.361 6.67111 11.1094 6.45546L7.99991 3.79015L4.89039 6.45546C4.63879 6.67111 4.26001 6.64197 4.04436 6.39038C3.82871 6.13878 3.85784 5.76 4.10944 5.54435L7.60944 2.54435ZM4.04436 9.60943C4.26001 9.35783 4.63879 9.32869 4.89039 9.54435L7.99991 12.2097L11.1094 9.54435C11.361 9.32869 11.7398 9.35783 11.9555 9.60943C12.1711 9.86102 12.142 10.2398 11.8904 10.4555L8.39039 13.4555C8.16569 13.6481 7.83413 13.6481 7.60944 13.4555L4.10944 10.4555C3.85784 10.2398 3.82871 9.86102 4.04436 9.60943Z"
                                fill="#68759C" />
                            </svg>
                          </div>
                        </template>
                        <b-dropdown-item class="p-0 m-0" :active="sortBy === 'Newest first'"
                          @click="changeSortBy('Newest first', 'live')">
                          <div class="ml-2 p-0 m-0">Newest first</div>
                        </b-dropdown-item>
                        <b-dropdown-item class="p-0 m-0" :active="sortBy === 'Oldest first'"
                          @click="changeSortBy('Oldest first', 'live')">
                          <div class="ml-2 p-0 m-0">Oldest first</div>
                        </b-dropdown-item>
                      </b-dropdown>
                    </li>
                    <li class="pr-0" v-for="(stream, index) in allInOneStreams" :key="index" draggable
                      @dragstart="startDrag($event, stream)" v-if="(allInOneStreams.length > 0)">
                      <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                        fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M5.5 4.5C6.05228 4.5 6.5 4.05228 6.5 3.5C6.5 2.94772 6.05228 2.5 5.5 2.5C4.94772 2.5 4.5 2.94772 4.5 3.5C4.5 4.05228 4.94772 4.5 5.5 4.5ZM10.5 4.5C11.0523 4.5 11.5 4.05228 11.5 3.5C11.5 2.94772 11.0523 2.5 10.5 2.5C9.94772 2.5 9.5 2.94772 9.5 3.5C9.5 4.05228 9.94772 4.5 10.5 4.5ZM6.5 8C6.5 8.55228 6.05228 9 5.5 9C4.94772 9 4.5 8.55228 4.5 8C4.5 7.44772 4.94772 7 5.5 7C6.05228 7 6.5 7.44772 6.5 8ZM10.5 9C11.0523 9 11.5 8.55228 11.5 8C11.5 7.44772 11.0523 7 10.5 7C9.94772 7 9.5 7.44772 9.5 8C9.5 8.55228 9.94772 9 10.5 9ZM6.5 12.5C6.5 13.0523 6.05228 13.5 5.5 13.5C4.94772 13.5 4.5 13.0523 4.5 12.5C4.5 11.9477 4.94772 11.5 5.5 11.5C6.05228 11.5 6.5 11.9477 6.5 12.5ZM10.5 13.5C11.0523 13.5 11.5 13.0523 11.5 12.5C11.5 11.9477 11.0523 11.5 10.5 11.5C9.94772 11.5 9.5 11.9477 9.5 12.5C9.5 13.0523 9.94772 13.5 10.5 13.5Z"
                          fill="#8794B5" />
                      </svg>
                      <div class="single-stream flex items-center">
                        <svg class="mr-2 pr-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                          viewBox="0 0 16 16" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M5 2.75H4.98856C4.29817 2.75 3.76471 2.75 3.33765 2.78489C2.90531 2.82021 2.56003 2.89254 2.25153 3.04973C1.73408 3.31338 1.31338 3.73408 1.04973 4.25153C0.89254 4.56003 0.820214 4.90531 0.784891 5.33765C0.75 5.76471 0.75 6.29817 0.75 6.98856V7V9V9.01144C0.75 9.70183 0.75 10.2353 0.784891 10.6624C0.820214 11.0947 0.89254 11.44 1.04973 11.7485C1.31338 12.2659 1.73408 12.6866 2.25153 12.9503C2.56003 13.1075 2.90531 13.1798 3.33765 13.2151C3.7647 13.25 4.29815 13.25 4.98851 13.25H4.98852H4.98854H4.98855H5H7H7.01145H7.01146H7.01148H7.01149C7.70185 13.25 8.2353 13.25 8.66235 13.2151C9.09469 13.1798 9.43997 13.1075 9.74847 12.9503C10.2659 12.6866 10.6866 12.2659 10.9503 11.7485C11.1075 11.44 11.1798 11.0947 11.2151 10.6624C11.2422 10.3306 11.2483 9.93465 11.2496 9.45081L14.1025 11.2339C14.602 11.5461 15.25 11.1869 15.25 10.5979V5.40212C15.25 4.81304 14.602 4.45391 14.1025 4.76612L11.2496 6.54917C11.2483 6.06534 11.2422 5.66939 11.2151 5.33765C11.1798 4.90531 11.1075 4.56003 10.9503 4.25153C10.6866 3.73408 10.2659 3.31338 9.74847 3.04973C9.43997 2.89254 9.09469 2.82021 8.66235 2.78489C8.23529 2.75 7.70183 2.75 7.01144 2.75H7H5Z"
                            fill="#AEBAD6" />
                        </svg>
                        <span class="text-normal text-s-ss text-dark-9" v-if="stream.name.length > 22">{{
                          stream.name.substring(0, 22) + ".."
                        }}</span>
                        <span class="text-normal text-s-ss text-dark-9" v-else>{{ stream.name
                        }}</span>
                      </div>
                      <svg class="included desk-block"
                        v-if="streamsModal && streamsModal.some(el => el.id === stream._id)"
                        xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M13.9248 4.42413C13.9248 4.42415 13.9248 4.42416 13.9248 4.42417L13.9248 4.42419L13.9244 4.42458L13.9225 4.42645L13.9145 4.43449L13.8818 4.46748C13.8528 4.49685 13.8095 4.54083 13.7534 4.59845C13.641 4.71369 13.4771 4.88342 13.2722 5.09983C12.8625 5.53278 12.2897 6.15194 11.6395 6.895C10.3359 8.3849 8.73462 10.3573 7.50919 12.3179C7.40856 12.4789 7.23766 12.5827 7.04841 12.5979C6.85915 12.6131 6.67388 12.5378 6.54885 12.3949L3.04885 8.39494C2.83064 8.14556 2.85591 7.7665 3.1053 7.5483C3.35468 7.33009 3.73374 7.35536 3.95194 7.60474L6.92775 11.0057C8.12734 9.19988 9.56139 7.4477 10.7365 6.10479C11.3988 5.34786 11.9823 4.71702 12.4007 4.27497C12.6099 4.05389 12.778 3.87986 12.8942 3.76073C12.9522 3.70116 12.9974 3.6553 13.0282 3.62413L13.0634 3.5885L13.0727 3.57918L13.0752 3.57668L13.0759 3.57598L13.0761 3.57576C13.0762 3.57569 13.0763 3.57564 13.5005 3.9999L13.0763 3.57564C13.3106 3.34132 13.6905 3.34132 13.9248 3.57564C14.1591 3.80994 14.1591 4.18982 13.9248 4.42413Z"
                          fill="#68759C" />
                      </svg>
                      <b-button size="sm" variant="primary"
                        :class="{ 'res-block': (streamsModal && streamsModal.some(el => el.id === stream._id)) }"
                        @click="onChange(null, stream)" class="ac_btn ml-auto px-2 py-0"
                        :disabled="streamsModal && streamsModal.some(el => el.id === stream._id)">
                        <span class="res-block">Add to Playlist</span>
                        <svg class="desk-block" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                          viewBox="0 0 16 16" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M7.9999 1.90039C8.33127 1.90039 8.5999 2.16902 8.5999 2.50039V7.40039H13.4999C13.8313 7.40039 14.0999 7.66902 14.0999 8.00039C14.0999 8.33176 13.8313 8.60039 13.4999 8.60039H8.5999V13.5004C8.5999 13.8318 8.33127 14.1004 7.9999 14.1004C7.66853 14.1004 7.3999 13.8318 7.3999 13.5004V8.60039H2.4999C2.16853 8.60039 1.8999 8.33176 1.8999 8.00039C1.8999 7.66902 2.16853 7.40039 2.4999 7.40039H7.3999V2.50039C7.3999 2.16902 7.66853 1.90039 7.9999 1.90039Z"
                            fill="white" />
                        </svg>
                      </b-button>
                    </li>
                    <li class="empty_tab" v-if="(allInOneStreams.length == 0)">
                      <p class="text-dark-9 text-s-m text-500 mb-1">There are no Livestreams.</p>
                      <a href="/app/dashboard">
                        <b-button size="sm" variant="primary">
                          Go to Livestream
                        </b-button>
                      </a>
                    </li>
                  </ul>
                </b-tab>
                <b-tab @click="changeRouteQuery('vod')" title="VOD"
                  :active="this.$route.query && this.$route.query.tab === 'vod'" class="playlist_vod_tab">
                  <li>
                    <svg class="search_icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                      fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M2.0999 6.7499C2.0999 4.18178 4.18178 2.0999 6.7499 2.0999C9.31803 2.0999 11.3999 4.18178 11.3999 6.7499C11.3999 9.31803 9.31803 11.3999 6.7499 11.3999C4.18178 11.3999 2.0999 9.31803 2.0999 6.7499ZM6.7499 0.899902C3.51904 0.899902 0.899902 3.51904 0.899902 6.7499C0.899902 9.98077 3.51904 12.5999 6.7499 12.5999C8.14923 12.5999 9.4338 12.1086 10.4405 11.2891L14.0756 14.9242C14.31 15.1585 14.6899 15.1585 14.9242 14.9242C15.1585 14.6899 15.1585 14.31 14.9242 14.0756L11.2891 10.4405C12.1086 9.4338 12.5999 8.14923 12.5999 6.7499C12.5999 3.51904 9.98077 0.899902 6.7499 0.899902Z"
                        fill="#8794B5" />
                    </svg>
                    <b-form-input ref="searchLive" v-model="searchLiveInput" placeholder="Search .."
                      class="search-form__field liveSearchfield" @focus="onSearchWidgetFocus" @blur="onSearchWidgetBlur">
                    </b-form-input>
                  </li>
                  <li class="d-flex align-items-center justify-content-between px-0">
                    <span class="text-dark-6 text-s-ss text-normal">{{ vodStreams.length }} vods</span>
                    <b-dropdown class="" variant="transparent" no-caret
                      toggle-class="p-0 d-flex align-items-center justify-content-between font-weight-normal"
                      menu-class="dropdown-menu_md">
                      <template #button-content>
                        <div class="d-flex align-items-center">
                          <span class="ml-1 text-dark-8 text-s-ss text-500">{{ sortBy }}</span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M7.60944 2.54435C7.83413 2.35175 8.16569 2.35175 8.39039 2.54435L11.8904 5.54435C12.142 5.76 12.1711 6.13878 11.9555 6.39038C11.7398 6.64197 11.361 6.67111 11.1094 6.45546L7.99991 3.79015L4.89039 6.45546C4.63879 6.67111 4.26001 6.64197 4.04436 6.39038C3.82871 6.13878 3.85784 5.76 4.10944 5.54435L7.60944 2.54435ZM4.04436 9.60943C4.26001 9.35783 4.63879 9.32869 4.89039 9.54435L7.99991 12.2097L11.1094 9.54435C11.361 9.32869 11.7398 9.35783 11.9555 9.60943C12.1711 9.86102 12.142 10.2398 11.8904 10.4555L8.39039 13.4555C8.16569 13.6481 7.83413 13.6481 7.60944 13.4555L4.10944 10.4555C3.85784 10.2398 3.82871 9.86102 4.04436 9.60943Z"
                              fill="#68759C" />
                          </svg>
                        </div>
                      </template>
                      <b-dropdown-item class="p-0 m-0" :active="sortBy === 'Newest first'"
                        @click="changeSortBy('Newest first', 'vod')">
                        <div class="ml-2 p-0 m-0">Newest first</div>
                      </b-dropdown-item>
                      <b-dropdown-item class="p-0 m-0" :active="sortBy === 'Oldest first'"
                        @click="changeSortBy('Oldest first', 'vod')">
                        <div class="ml-2 p-0 m-0">Oldest first</div>
                      </b-dropdown-item>
                    </b-dropdown>
                  </li>
                  <li v-for="(stream, index) in vodStreams" :key="index" class="d-flex flex-wrap pr-0"
                    v-if="(vodStreams.length > 0)">
                    <div class="w-100 d-flex align-items-center cursor-pointer" role="tab">
                      <b-button variant="icon" size="xs" :class="true ? null : 'collapsed'"
                        :aria-expanded="true ? 'true' : 'false'" aria-controls="collapse-4"
                        @click="getVodFiles(stream._id)" class="pl-0 py-0 pr-0 collapse-b">
                        <svg width="6" class="mr-3 " height="10" viewBox="0 0 6 10" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M2.73137 1.73123L4.86863 3.86848C5.26465 4.2645 5.46265 4.46251 5.53684 4.69084C5.6021 4.89168 5.6021 5.10803 5.53684 5.30887C5.46265 5.5372 5.26465 5.73521 4.86863 6.13123L2.73137 8.26848C1.87462 9.12524 1.44624 9.55361 1.07846 9.58256C0.759341 9.60767 0.447486 9.4785 0.239594 9.23509C0 8.95456 0 8.34874 0 7.13711V2.8626C0 1.65096 0 1.04515 0.239594 0.76462C0.447486 0.52121 0.759341 0.392035 1.07846 0.417151C1.44624 0.446096 1.87462 0.874473 2.73137 1.73123Z"
                            fill="#D1DBF0" />
                        </svg>
                        <svg class="mr-3 pr-0" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                          viewBox="0 0 16 16" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M5.89144 1.44539C5.67514 1.39964 5.45418 1.39976 5.18019 1.39992L5.13108 1.39994H3.9L3.8759 1.39994C3.47638 1.39993 3.14066 1.39992 2.86594 1.42237C2.57871 1.44584 2.30573 1.4968 2.04662 1.62883C1.65147 1.83016 1.33022 2.15142 1.12888 2.54656C0.996856 2.80567 0.945892 3.07865 0.922424 3.36588C0.899979 3.6406 0.899986 3.9763 0.899994 4.37581V4.37584V4.39994V10.5999V10.624V10.624C0.899986 11.0235 0.899979 11.3592 0.922424 11.634C0.945892 11.9212 0.996856 12.1942 1.12888 12.4533C1.33022 12.8484 1.65147 13.1697 2.04662 13.371C2.30573 13.503 2.57871 13.554 2.86594 13.5775C3.14067 13.5999 3.47639 13.5999 3.87591 13.5999H3.9H12.1H12.1241C12.5236 13.5999 12.8593 13.5999 13.1341 13.5775C13.4213 13.554 13.6943 13.503 13.9534 13.371C14.3485 13.1697 14.6698 12.8484 14.8711 12.4533C15.0031 12.1942 15.0541 11.9212 15.0776 11.634C15.1 11.3592 15.1 11.0235 15.1 10.624V10.5999V6.89994V6.87586C15.1 6.47633 15.1 6.14061 15.0776 5.86588C15.0541 5.57865 15.0031 5.30567 14.8711 5.04656C14.6698 4.65142 14.3485 4.33016 13.9534 4.12883C13.6943 3.9968 13.4213 3.94584 13.1341 3.92237C12.8593 3.89992 12.5236 3.89993 12.1241 3.89994H12.1241L12.1 3.89994H9.86892C9.52226 3.89994 9.43474 3.89694 9.35685 3.88046C9.27515 3.86318 9.19626 3.83462 9.12243 3.79559C9.05205 3.75838 8.98289 3.70466 8.71658 3.48274L7.05163 2.09528L7.01391 2.06382C6.80352 1.88829 6.63386 1.74674 6.4384 1.64341C6.26615 1.55235 6.08207 1.4857 5.89144 1.44539Z"
                            fill="#AEBAD6" />
                        </svg>
                      </b-button>

                      <span @click="getVodFiles(stream._id)"
                        class="d-block text-truncate text-normal text-s-ss text-dark-9 w-100">
                        <b-badge variant="dark-3" v-if="stream.liveParent"
                          class="badge_beta align-self-center mr-2">L-V</b-badge>
                        {{ stream.name.substring(0, 20) }}
                      </span>
                    </div>

                    <b-collapse accordion="vod-files" role="tabpanel" :id="'folder' + stream._id" class="mt-3 w-100">
                      <b-list-group v-show="!loading" class="pl-0">
                        <b-list-group-item button variant="dark-3" v-for="(file, index) in  vodFiles" :key="index"
                          draggable @dragstart="startDrag($event, file)"
                          class="d-flex align-items-center text-dark-8 single-file px-0 py-3 text-s-s text-truncate border-0">
                          <svg class="mr-0" style="transform: translateX(-4px);" xmlns="http://www.w3.org/2000/svg"
                            width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M5.5 4.5C6.05228 4.5 6.5 4.05228 6.5 3.5C6.5 2.94772 6.05228 2.5 5.5 2.5C4.94772 2.5 4.5 2.94772 4.5 3.5C4.5 4.05228 4.94772 4.5 5.5 4.5ZM10.5 4.5C11.0523 4.5 11.5 4.05228 11.5 3.5C11.5 2.94772 11.0523 2.5 10.5 2.5C9.94772 2.5 9.5 2.94772 9.5 3.5C9.5 4.05228 9.94772 4.5 10.5 4.5ZM6.5 8C6.5 8.55228 6.05228 9 5.5 9C4.94772 9 4.5 8.55228 4.5 8C4.5 7.44772 4.94772 7 5.5 7C6.05228 7 6.5 7.44772 6.5 8ZM10.5 9C11.0523 9 11.5 8.55228 11.5 8C11.5 7.44772 11.0523 7 10.5 7C9.94772 7 9.5 7.44772 9.5 8C9.5 8.55228 9.94772 9 10.5 9ZM6.5 12.5C6.5 13.0523 6.05228 13.5 5.5 13.5C4.94772 13.5 4.5 13.0523 4.5 12.5C4.5 11.9477 4.94772 11.5 5.5 11.5C6.05228 11.5 6.5 11.9477 6.5 12.5ZM10.5 13.5C11.0523 13.5 11.5 13.0523 11.5 12.5C11.5 11.9477 11.0523 11.5 10.5 11.5C9.94772 11.5 9.5 11.9477 9.5 12.5C9.5 13.0523 9.94772 13.5 10.5 13.5Z"
                              fill="#8794B5" />
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 ml-1" width="16" height="16"
                            viewBox="0 0 16 16" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M5.49996 1.3999H5.47417C5.14271 1.3999 4.84296 1.3999 4.57156 1.40411C4.54815 1.40133 4.52432 1.3999 4.50017 1.3999C4.46797 1.3999 4.43636 1.40244 4.40553 1.40732C4.18796 1.41247 3.98981 1.42119 3.8091 1.43596C3.35511 1.47305 2.95864 1.55126 2.59257 1.73779C2.00926 2.035 1.53502 2.50924 1.23782 3.09255C1.0513 3.45863 0.973088 3.85509 0.936001 4.30908C0.899941 4.75048 0.899951 5.29596 0.899964 5.97415L0.899964 5.99995L0.900005 9.99995L0.900005 10.0257C0.900006 10.7039 0.900007 11.2494 0.936075 11.6908C0.973171 12.1448 1.05139 12.5412 1.23791 12.9073C1.53512 13.4906 2.00936 13.9648 2.59266 14.262C2.95873 14.4485 3.35518 14.5268 3.80917 14.5639C3.98986 14.5786 4.18799 14.5873 4.40552 14.5925C4.43635 14.5974 4.46796 14.5999 4.50017 14.5999C4.52433 14.5999 4.54815 14.5985 4.57156 14.5957C4.84297 14.5999 5.14274 14.5999 5.4742 14.5999H5.47421H5.47422H5.5H10.5H10.5258H10.5258H10.5258H10.5259C10.8574 14.5999 11.1573 14.5999 11.4287 14.5957C11.4522 14.5985 11.476 14.5999 11.5002 14.5999C11.5324 14.5999 11.564 14.5974 11.5949 14.5925C11.8123 14.5873 12.0103 14.5786 12.1909 14.5638C12.6449 14.5268 13.0413 14.4485 13.4074 14.262C13.9907 13.9648 14.4649 13.4906 14.7622 12.9073C14.9487 12.5412 15.0269 12.1447 15.064 11.6907C15.1 11.2493 15.1 10.7039 15.1 10.0257V10.0257V9.99986L15.1 9.51917C15.1002 9.51278 15.1003 9.50635 15.1003 9.49991C15.1003 9.49346 15.1002 9.48703 15.1 9.48063L15.1 5.99986V5.97409C15.1 5.2959 15.1 4.75042 15.0639 4.30902C15.0268 3.85504 14.9486 3.45858 14.7621 3.09251C14.4648 2.50922 13.9906 2.03498 13.4073 1.73778C13.0412 1.55126 12.6448 1.47305 12.1908 1.43596C12.0102 1.4212 11.8122 1.41249 11.5949 1.40734C11.564 1.40244 11.5324 1.3999 11.5002 1.3999C11.476 1.3999 11.4522 1.40133 11.4287 1.40411C11.1572 1.3999 10.8574 1.3999 10.5258 1.3999H10.5H5.49996ZM3.13736 2.80699C3.30508 2.72153 3.52445 2.66368 3.90017 2.63252V5.14991H2.10318C2.10689 4.85885 2.11487 4.61668 2.13202 4.40679C2.16304 4.02701 2.22107 3.80604 2.30703 3.63733C2.48919 3.27982 2.77985 2.98915 3.13736 2.80699ZM2.09997 6.34991L2.09999 8.89991H3.90017V6.34991H2.09997ZM5.10017 2.6002V8.89991H10.9002V2.6002C10.7747 2.59992 10.6416 2.5999 10.5 2.5999H5.49996C5.35849 2.5999 5.2255 2.59992 5.10017 2.6002ZM2.10001 10.0999H3.90017V13.3673C3.5245 13.3361 3.30515 13.2783 3.13744 13.1928C2.77994 13.0107 2.48927 12.72 2.30711 12.3625C2.22115 12.1938 2.16312 11.9728 2.13209 11.5931C2.10199 11.2247 2.10013 10.7569 2.10001 10.0999ZM5.10017 10.0999V13.3996C5.22551 13.3999 5.35852 13.3999 5.5 13.3999H10.5C10.6416 13.3999 10.7747 13.3999 10.9002 13.3996V10.0999H5.10017ZM12.8626 13.1928C12.6949 13.2782 12.4757 13.3361 12.1002 13.3673V10.0999H13.9C13.8999 10.7569 13.898 11.2247 13.868 11.593C13.8369 11.9728 13.7789 12.1938 13.6929 12.3625C13.5108 12.72 13.2201 13.0107 12.8626 13.1928ZM13.9 8.89991H12.1002V6.34991H13.9L13.9 8.89991ZM13.8967 5.14991H12.1002V2.63255C12.4756 2.66372 12.6949 2.72156 12.8625 2.80699C13.22 2.98914 13.5107 3.2798 13.6929 3.63731C13.7788 3.80602 13.8368 4.02698 13.8679 4.40675C13.885 4.61665 13.893 4.85883 13.8967 5.14991Z"
                              fill="#AEBAD6" />
                          </svg>
                          <span class="text-normal text-s-ss text-dark-9" v-if="file.fileName.length > 18">{{
                            file.fileName.substring(0, 18) + ".." }}</span>
                          <span class="text-normal text-s-ss text-dark-9" v-else>{{ file.fileName
                          }}</span>
                          <svg class="included desk-block"
                            v-if="streamsModal && streamsModal.some(el => el.id === (file.refId ? file.refId : file.id))"
                            xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M13.9248 4.42413C13.9248 4.42415 13.9248 4.42416 13.9248 4.42417L13.9248 4.42419L13.9244 4.42458L13.9225 4.42645L13.9145 4.43449L13.8818 4.46748C13.8528 4.49685 13.8095 4.54083 13.7534 4.59845C13.641 4.71369 13.4771 4.88342 13.2722 5.09983C12.8625 5.53278 12.2897 6.15194 11.6395 6.895C10.3359 8.3849 8.73462 10.3573 7.50919 12.3179C7.40856 12.4789 7.23766 12.5827 7.04841 12.5979C6.85915 12.6131 6.67388 12.5378 6.54885 12.3949L3.04885 8.39494C2.83064 8.14556 2.85591 7.7665 3.1053 7.5483C3.35468 7.33009 3.73374 7.35536 3.95194 7.60474L6.92775 11.0057C8.12734 9.19988 9.56139 7.4477 10.7365 6.10479C11.3988 5.34786 11.9823 4.71702 12.4007 4.27497C12.6099 4.05389 12.778 3.87986 12.8942 3.76073C12.9522 3.70116 12.9974 3.6553 13.0282 3.62413L13.0634 3.5885L13.0727 3.57918L13.0752 3.57668L13.0759 3.57598L13.0761 3.57576C13.0762 3.57569 13.0763 3.57564 13.5005 3.9999L13.0763 3.57564C13.3106 3.34132 13.6905 3.34132 13.9248 3.57564C14.1591 3.80994 14.1591 4.18982 13.9248 4.42413Z"
                              fill="#68759C" />
                          </svg>
                          <b-button
                            :class="{ 'res-block': (streamsModal && streamsModal.some(el => el.id === (file.refId ? file.refId : file.id))) }"
                            size="sm" variant="primary" @click="onChange(null, file)"
                            class="ml-auto px-2 py-0 addPlaylist_btn_vod"
                            :disabled="streamsModal && streamsModal.some(el => el.id === (file.refId ? file.refId : file.id))">
                            <span class="res-block">Add to Playlist</span>
                            <svg class="desk-block" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                              viewBox="0 0 16 16" fill="none">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M7.9999 1.90039C8.33127 1.90039 8.5999 2.16902 8.5999 2.50039V7.40039H13.4999C13.8313 7.40039 14.0999 7.66902 14.0999 8.00039C14.0999 8.33176 13.8313 8.60039 13.4999 8.60039H8.5999V13.5004C8.5999 13.8318 8.33127 14.1004 7.9999 14.1004C7.66853 14.1004 7.3999 13.8318 7.3999 13.5004V8.60039H2.4999C2.16853 8.60039 1.8999 8.33176 1.8999 8.00039C1.8999 7.66902 2.16853 7.40039 2.4999 7.40039H7.3999V2.50039C7.3999 2.16902 7.66853 1.90039 7.9999 1.90039Z"
                                fill="white" />
                            </svg>
                          </b-button>
                        </b-list-group-item>
                      </b-list-group>
                      <div class="col-6" v-if="loading">
                        <Spinner text="Retrieving data..." classes="text-dark-8 my-2 text-left" textClasses="text-s-xs"
                          spinner-color="var(--c-dark-8)" spinner-size="14px" />
                      </div>
                    </b-collapse>
                  </li>
                  <li class="empty_tab" v-if="(vodStreams.length == 0)">
                    <p class="text-dark-9 text-s-m text-500 mb-1">There are no Videos</p>
                    <a href="/app/vods">
                      <b-button size="sm" variant="primary">
                        Go to Video hosting
                      </b-button>
                    </a>
                  </li>
                </b-tab>
              </b-tabs>
            </div>
          </div>
          <div class="playlist_info w-100" :class="{ 'second-step': (this.resStep == 2) }">
            <b-tabs class="tabs-light pb-9rem">
              <b-tab title="Embed" active>
                <h3 class="text-s-m text-500 mt-4 mb-2">Configure playlist</h3>
                <p class="text-dark-8 text-s-s">Set settings and copy & paste the HTML code to your website
                  to display the video.</p>
                <b-list-group horizontal class="mb-2 relative z-1 toggle-features">
                  <b-list-group-item class="pl-4 border-0 d-flex align-items-center">
                    <b-form-checkbox @change="toggleFeature('responsive')" v-model="features.responsive.status" size="sm"
                      switch>
                    </b-form-checkbox>
                    <span class="text-dark-9 text-s-ss text-500">Responsive</span>
                  </b-list-group-item>
                  <b-list-group-item class="pl-3 border-0 d-flex align-items-center">
                    <b-form-checkbox @change="toggleFeature('autoPlayNext')" v-model="features.autoPlayNext.status"
                      size="sm" switch>
                    </b-form-checkbox>
                    <span class="text-dark-9 text-s-ss text-500">Autoplay next item</span>
                  </b-list-group-item>
                  <b-list-group-item class="pl-3 border-0 d-flex align-items-center">
                    <b-form-checkbox size="sm" @change="toggleFeature('loop')" v-model="features.loop.status" switch>
                    </b-form-checkbox>
                    <span class="text-dark-9 text-s-ss text-500">Loop</span>
                  </b-list-group-item>
                  <b-list-group-item class="pl-3 border-0 d-flex align-items-center">
                    <b-form-checkbox size="sm" @change="toggleFeature('shuffle')" v-model="features.shuffle.status" switch>
                    </b-form-checkbox>
                    <span class="text-dark-9 text-s-ss text-500">Shuffle</span>
                  </b-list-group-item>
                </b-list-group>
                <b-form-textarea class="pr-4 text-s-ss" rows="3" @click="clipboardCopy(getEpisodeIframeSnippet)"
                  :value="getEpisodeIframeSnippet"></b-form-textarea>
                <b-row class="mt-3 btn-row">
                  <b-col>
                    <b-button @click="clipboardCopy(getEpisodeIframeSnippet)" size="sm" variant="outline-secondary">
                      <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M4.20039 0.399903H4.17526H4.17524C3.63655 0.399896 3.19598 0.39989 2.83794 0.429144C2.46733 0.459424 2.13261 0.524012 1.82002 0.683286C1.33079 0.932557 0.933045 1.33031 0.683774 1.81953C0.524501 2.13212 0.459912 2.46684 0.429632 2.83745C0.400379 3.1955 0.400384 3.63606 0.400391 4.17476V4.17477V4.1999V6.7999V6.82504V6.82505C0.400384 7.36375 0.400379 7.80431 0.429632 8.16236C0.459912 8.53297 0.524501 8.86769 0.683774 9.18028C0.933045 9.6695 1.33079 10.0672 1.82002 10.3165C2.13261 10.4758 2.46733 10.5404 2.83794 10.5707C3.00669 10.5844 3.19377 10.5917 3.40082 10.5956C3.40377 11.104 3.42289 11.4955 3.53837 11.8356C3.7982 12.6011 4.39923 13.2021 5.16465 13.4619C5.57316 13.6006 6.05553 13.6003 6.72575 13.5999L6.83373 13.5999H9.80039H9.82551H9.82558C10.3643 13.5999 10.8048 13.5999 11.1628 13.5707C11.5335 13.5404 11.8682 13.4758 12.1808 13.3165C12.67 13.0672 13.0677 12.6695 13.317 12.1803C13.4763 11.8677 13.5409 11.533 13.5711 11.1624C13.6004 10.8043 13.6004 10.3638 13.6004 9.82509V9.82502V9.7999V6.83324L13.6004 6.72526C13.6008 6.05504 13.6011 5.57267 13.4624 5.16416C13.2026 4.39874 12.6016 3.79771 11.8361 3.53789C11.4959 3.42241 11.1045 3.40328 10.5961 3.40033C10.5922 3.19328 10.5849 3.0062 10.5711 2.83745C10.5409 2.46684 10.4763 2.13212 10.317 1.81953C10.0677 1.33031 9.66999 0.932557 9.18077 0.683286C8.86817 0.524012 8.53345 0.459424 8.16285 0.429144C7.8048 0.39989 7.36424 0.399896 6.82554 0.399903H6.82553H6.80039H4.20039ZM10.6004 4.60128V6.7999V6.82502V6.82509C10.6004 7.36377 10.6004 7.80432 10.5711 8.16236C10.5409 8.53297 10.4763 8.86769 10.317 9.18028C10.0677 9.6695 9.66999 10.0672 9.18077 10.3165C8.86817 10.4758 8.53345 10.5404 8.16285 10.5707C7.80481 10.5999 7.36426 10.5999 6.82558 10.5999H6.82551H6.80039H4.60177C4.60597 11.0943 4.62174 11.2939 4.67469 11.4499C4.81459 11.8621 5.13823 12.1857 5.55037 12.3256C5.7456 12.3919 6.00929 12.3999 6.83373 12.3999H9.80039C10.3703 12.3999 10.7617 12.3994 11.0651 12.3746C11.3615 12.3504 11.5207 12.306 11.636 12.2473C11.8994 12.1131 12.1136 11.8989 12.2478 11.6355C12.3065 11.5203 12.3509 11.361 12.3751 11.0646C12.3999 10.7612 12.4004 10.3699 12.4004 9.7999V6.83324C12.4004 6.0088 12.3924 5.74512 12.3261 5.54989C12.1862 5.13774 11.8626 4.81411 11.4504 4.6742C11.2944 4.62126 11.0948 4.60549 10.6004 4.60128ZM2.3648 1.75249C2.48004 1.69378 2.63925 1.64938 2.93565 1.62516C3.23906 1.60037 3.63044 1.5999 4.20039 1.5999H6.80039C7.37034 1.5999 7.76172 1.60037 8.06513 1.62516C8.36153 1.64938 8.52075 1.69378 8.63598 1.75249C8.8994 1.88672 9.11358 2.10089 9.2478 2.36432C9.30651 2.47955 9.35092 2.63877 9.37514 2.93517C9.39992 3.23857 9.40039 3.62995 9.40039 4.1999V6.7999C9.40039 7.36986 9.39992 7.76124 9.37514 8.06464C9.35092 8.36104 9.30651 8.52026 9.2478 8.63549C9.11358 8.89892 8.8994 9.11309 8.63598 9.24731C8.52075 9.30602 8.36153 9.35043 8.06513 9.37465C7.76172 9.39944 7.37034 9.3999 6.80039 9.3999H4.20039C3.63044 9.3999 3.23906 9.39944 2.93565 9.37465C2.63925 9.35043 2.48004 9.30602 2.3648 9.24731C2.10138 9.11309 1.88721 8.89892 1.75298 8.63549C1.69427 8.52026 1.64986 8.36104 1.62565 8.06464C1.60086 7.76124 1.60039 7.36986 1.60039 6.7999V4.1999C1.60039 3.62995 1.60086 3.23857 1.62565 2.93517C1.64986 2.63877 1.69427 2.47955 1.75298 2.36432C1.88721 2.10089 2.10138 1.88672 2.3648 1.75249Z"
                          fill="currentColor" />
                      </svg>
                      Copy to Clipboard
                    </b-button>
                    <b-button @click="clipboardCopy(getPlayerUrl())" class="ml-2" size="sm" variant="outline-secondary">
                      <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M4.20039 0.399903H4.17526H4.17524C3.63655 0.399896 3.19598 0.39989 2.83794 0.429144C2.46733 0.459424 2.13261 0.524012 1.82002 0.683286C1.33079 0.932557 0.933045 1.33031 0.683774 1.81953C0.524501 2.13212 0.459912 2.46684 0.429632 2.83745C0.400379 3.1955 0.400384 3.63606 0.400391 4.17476V4.17477V4.1999V6.7999V6.82504V6.82505C0.400384 7.36375 0.400379 7.80431 0.429632 8.16236C0.459912 8.53297 0.524501 8.86769 0.683774 9.18028C0.933045 9.6695 1.33079 10.0672 1.82002 10.3165C2.13261 10.4758 2.46733 10.5404 2.83794 10.5707C3.00669 10.5844 3.19377 10.5917 3.40082 10.5956C3.40377 11.104 3.42289 11.4955 3.53837 11.8356C3.7982 12.6011 4.39923 13.2021 5.16465 13.4619C5.57316 13.6006 6.05553 13.6003 6.72575 13.5999L6.83373 13.5999H9.80039H9.82551H9.82558C10.3643 13.5999 10.8048 13.5999 11.1628 13.5707C11.5335 13.5404 11.8682 13.4758 12.1808 13.3165C12.67 13.0672 13.0677 12.6695 13.317 12.1803C13.4763 11.8677 13.5409 11.533 13.5711 11.1624C13.6004 10.8043 13.6004 10.3638 13.6004 9.82509V9.82502V9.7999V6.83324L13.6004 6.72526C13.6008 6.05504 13.6011 5.57267 13.4624 5.16416C13.2026 4.39874 12.6016 3.79771 11.8361 3.53789C11.4959 3.42241 11.1045 3.40328 10.5961 3.40033C10.5922 3.19328 10.5849 3.0062 10.5711 2.83745C10.5409 2.46684 10.4763 2.13212 10.317 1.81953C10.0677 1.33031 9.66999 0.932557 9.18077 0.683286C8.86817 0.524012 8.53345 0.459424 8.16285 0.429144C7.8048 0.39989 7.36424 0.399896 6.82554 0.399903H6.82553H6.80039H4.20039ZM10.6004 4.60128V6.7999V6.82502V6.82509C10.6004 7.36377 10.6004 7.80432 10.5711 8.16236C10.5409 8.53297 10.4763 8.86769 10.317 9.18028C10.0677 9.6695 9.66999 10.0672 9.18077 10.3165C8.86817 10.4758 8.53345 10.5404 8.16285 10.5707C7.80481 10.5999 7.36426 10.5999 6.82558 10.5999H6.82551H6.80039H4.60177C4.60597 11.0943 4.62174 11.2939 4.67469 11.4499C4.81459 11.8621 5.13823 12.1857 5.55037 12.3256C5.7456 12.3919 6.00929 12.3999 6.83373 12.3999H9.80039C10.3703 12.3999 10.7617 12.3994 11.0651 12.3746C11.3615 12.3504 11.5207 12.306 11.636 12.2473C11.8994 12.1131 12.1136 11.8989 12.2478 11.6355C12.3065 11.5203 12.3509 11.361 12.3751 11.0646C12.3999 10.7612 12.4004 10.3699 12.4004 9.7999V6.83324C12.4004 6.0088 12.3924 5.74512 12.3261 5.54989C12.1862 5.13774 11.8626 4.81411 11.4504 4.6742C11.2944 4.62126 11.0948 4.60549 10.6004 4.60128ZM2.3648 1.75249C2.48004 1.69378 2.63925 1.64938 2.93565 1.62516C3.23906 1.60037 3.63044 1.5999 4.20039 1.5999H6.80039C7.37034 1.5999 7.76172 1.60037 8.06513 1.62516C8.36153 1.64938 8.52075 1.69378 8.63598 1.75249C8.8994 1.88672 9.11358 2.10089 9.2478 2.36432C9.30651 2.47955 9.35092 2.63877 9.37514 2.93517C9.39992 3.23857 9.40039 3.62995 9.40039 4.1999V6.7999C9.40039 7.36986 9.39992 7.76124 9.37514 8.06464C9.35092 8.36104 9.30651 8.52026 9.2478 8.63549C9.11358 8.89892 8.8994 9.11309 8.63598 9.24731C8.52075 9.30602 8.36153 9.35043 8.06513 9.37465C7.76172 9.39944 7.37034 9.3999 6.80039 9.3999H4.20039C3.63044 9.3999 3.23906 9.39944 2.93565 9.37465C2.63925 9.35043 2.48004 9.30602 2.3648 9.24731C2.10138 9.11309 1.88721 8.89892 1.75298 8.63549C1.69427 8.52026 1.64986 8.36104 1.62565 8.06464C1.60086 7.76124 1.60039 7.36986 1.60039 6.7999V4.1999C1.60039 3.62995 1.60086 3.23857 1.62565 2.93517C1.64986 2.63877 1.69427 2.47955 1.75298 2.36432C1.88721 2.10089 2.10138 1.88672 2.3648 1.75249Z"
                          fill="currentColor" />
                      </svg>
                      Copy Direct Url
                    </b-button>
                    <b-button target="_blank" :href="getPlayerUrl()" role="link" class="ml-2" size="sm"
                      variant="outline-secondary">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M9.50039 1.40039C9.16902 1.40039 8.90039 1.66902 8.90039 2.00039C8.90039 2.33176 9.16902 2.60039 9.50039 2.60039H12.5519L7.57613 7.57613C7.34181 7.81044 7.34181 8.19034 7.57613 8.42465C7.81044 8.65897 8.19034 8.65897 8.42465 8.42465L13.4004 3.44892V6.50039C13.4004 6.83176 13.669 7.10039 14.0004 7.10039C14.3318 7.10039 14.6004 6.83176 14.6004 6.50039V2.00039C14.6004 1.66902 14.3318 1.40039 14.0004 1.40039H9.50039ZM6.00039 3.40039L5.97459 3.40039C5.29641 3.40038 4.75093 3.40038 4.30954 3.43644C3.85555 3.47354 3.45909 3.55175 3.09302 3.73827C2.50972 4.03548 2.03548 4.50972 1.73827 5.09302C1.55175 5.45909 1.47354 5.85555 1.43644 6.30954C1.40038 6.75093 1.40039 7.29641 1.40039 7.97459V8.00039V10.0004V10.0262C1.40039 10.7044 1.40038 11.2498 1.43644 11.6912C1.47354 12.1452 1.55175 12.5417 1.73827 12.9078C2.03548 13.4911 2.50972 13.9653 3.09302 14.2625C3.45909 14.449 3.85555 14.5272 4.30954 14.5643C4.75094 14.6004 5.29642 14.6004 5.97461 14.6004H6.00039H8.00039H8.02617C8.70436 14.6004 9.24984 14.6004 9.69125 14.5643C10.1452 14.5272 10.5417 14.449 10.9078 14.2625C11.4911 13.9653 11.9653 13.4911 12.2625 12.9078C12.449 12.5417 12.5272 12.1452 12.5643 11.6912C12.6004 11.2498 12.6004 10.7044 12.6004 10.0262V10.0262V10.0004C12.6004 9.66902 12.3318 9.40039 12.0004 9.40039C11.669 9.40039 11.4004 9.66902 11.4004 10.0004C11.4004 10.7104 11.3999 11.2067 11.3683 11.5935C11.3373 11.9733 11.2793 12.1943 11.1933 12.363C11.0111 12.7205 10.7205 13.0111 10.363 13.1933C10.1943 13.2793 9.9733 13.3373 9.59353 13.3683C9.20675 13.3999 8.71036 13.4004 8.00039 13.4004H6.00039C5.29042 13.4004 4.79404 13.3999 4.40725 13.3683C4.02748 13.3373 3.80652 13.2793 3.63781 13.1933C3.2803 13.0111 2.98964 12.7205 2.80748 12.363C2.72152 12.1943 2.66349 11.9733 2.63246 11.5935C2.60086 11.2067 2.60039 10.7104 2.60039 10.0004V8.00039C2.60039 7.29042 2.60086 6.79403 2.63246 6.40725C2.66349 6.02748 2.72152 5.80652 2.80748 5.63781C2.98964 5.2803 3.2803 4.98964 3.63781 4.80748C3.80652 4.72152 4.02748 4.66349 4.40725 4.63246C4.79404 4.60086 5.29043 4.60039 6.00039 4.60039C6.33176 4.60039 6.60039 4.33176 6.60039 4.00039C6.60039 3.66902 6.33176 3.40039 6.00039 3.40039Z"
                          fill="#AEBAD6" />
                      </svg>
                    </b-button>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Social Share">
								<h3 class="text-s-l text-500 mt-4 mb-2">Social share</h3>
								<p class="text-dark-8 text-s-m">
									Manage where viewers can share the videos.
								</p>

								<b-button :variant="socialSharingEnabled ? 'outline-secondary' : 'primary'" class="mt-2"
									@click="onSocialSharingToggle">
									{{ socialSharingEnabled ? 'Disable sharing' : 'Enable sharing' }}
								</b-button>

								<b-list-group horizontal class="mb-2 relative z-1 toggle-features mt-4">
									<b-list-group-item class="pl-4 border-0 d-flex align-items-center">
										<b-form-checkbox size="sm" @change="toggleFeature('shareFacebook')" :disabled="!socialSharingEnabled"
											v-model="features.shareFacebook.status" switch>
										</b-form-checkbox>
										<span class="text-dark-9 text-s-s text-500 text-nowrap">Facebook</span>
									</b-list-group-item>
									<b-list-group-item class="pl-4 border-0 d-flex align-items-center">
										<b-form-checkbox @change="toggleFeature('shareTwitter')" :disabled="!socialSharingEnabled"
											v-model="features.shareTwitter.status" size="sm" switch>
										</b-form-checkbox>
										<span class="text-dark-9 text-s-s text-500">Twitter</span>
									</b-list-group-item>
									<b-list-group-item class="pl-4 border-0 d-flex align-items-center">
										<b-form-checkbox @change="toggleFeature('shareLinkedIn')" :disabled="!socialSharingEnabled"
											v-model="features.shareLinkedIn.status" size="sm" switch>
										</b-form-checkbox>
										<span class="text-dark-9 text-s-s text-500">LinkedIn</span>
									</b-list-group-item>
									<b-list-group-item class="pl-4 border-0 d-flex align-items-center">
										<b-form-checkbox @change="toggleFeature('shareReddit')" :disabled="!socialSharingEnabled"
											v-model="features.shareReddit.status" size="sm" switch>
										</b-form-checkbox>
										<span class="text-dark-9 text-s-s text-500 text-nowrap">Reddit</span>
									</b-list-group-item>
									<b-list-group-item class="pl-4 border-0 d-flex align-items-center">
										<b-form-checkbox size="sm" @change="toggleFeature('shareEmail')" :disabled="!socialSharingEnabled"
											v-model="features.shareEmail.status" switch>
										</b-form-checkbox>
										<span class="text-dark-9 text-s-s text-500">Email</span>
									</b-list-group-item>
									<b-list-group-item class="pl-4 border-0 d-flex align-items-center">
										<b-form-checkbox @change="toggleFeature('shareWhatsApp')" :disabled="!socialSharingEnabled"
											v-model="features.shareWhatsApp.status" size="sm" switch>
										</b-form-checkbox>
										<span class="text-dark-9 text-s-s text-500">WhatsApp</span>
									</b-list-group-item>
								</b-list-group>
							</b-tab>
              <b-tab title="Settings">
								<playlist-security-settings :playlistSettings="this.playlistSettings" @on-update="onUpdateSecurity" />
							</b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </main>
    <add-playlist-modal @playlist-created="createdPlaylist" :playlist="playlist" />
    <demo-video-modal videoid="tDgMUJ40LkS3jrnJeMTQc" />
    <confirm-modal modalId="delete-playlist" message="Are you sure you want to delete the playlist?" modal-type="danger"
      @modal-confirm="removePlaylists(currentIndexed)" />
  </b-container>
</template>

<script>
import _ from "lodash";
import { mapGetters } from 'vuex'
import Spinner from "@/components/ui/Spinner.vue"
import PlaylistService from "@/services/Playlistservice";
import AddPlaylistModal from "@/components/modals/AddPlaylistModal.vue"
import draggable from 'vuedraggable';
import DemoVideoModal from '@/components/modals/DemoVideoModal.vue';
import ConfirmModal from '@/components/modals/ConfirmModal.vue'
import PlaylistSecuritySettings from './PlaylistSecuritySettings.vue';

const featuresDefault = {
  embedAutoplay: {
    status: false,
  },
  responsive: {
    status: true,
  },
  loop: {
    status: false,
  },
  shuffle: {
    status: false,
  },
  autoPlayNext: {
    status: false,
  },
  socialSharingEnabled: {
    status: false,
  },
  shareFacebook: {
    status: true,
  },
  shareTwitter: {
    status: true,
  },
  shareLinkedIn: {
    status: false
  },
  shareReddit: {
    status: false
  },
  shareEmail: {
    status: false
  },
  shareWhatsApp: {
    status: false
  },
  countryBlock: {
    enabled: false,
    value: [],
    valueType: 'array'
  },
  countryWhitelists: {
    enabled: false,
    value: [],
    valueType: 'array'
  },
  domainWhitelists: {
    enabled: false,
    value: [],
    valueType: 'array'
  }
};

export default {
  name: "ManagePlaylists",
  components: {
    Spinner,
    AddPlaylistModal,
    DemoVideoModal,
    ConfirmModal,
    draggable,
    PlaylistSecuritySettings
  },
  computed: {
    ...mapGetters({
      loadingStatus: "Ui/loadingStatus",
      hasLiveSubscription: "User/hasLiveSubscription",
      playlist: "Playlist/playlist",
      allInOneStreams: "Streams/allInOneStreams",
      vodStreams: "Streams/vodStreams",
      vodFiles: "Streams/vodFiles",
      isLiveSubscriptionExpired: "User/isLiveSubscriptionExpired"
    }),
    liveStreams() {
      return [...this.allInOneStreams]
    },
    playlistCopy() {
      let currentPlaylist = [...this.playlist];
      if (!this.sortPlaylistTrigger) {
        if (this.searchPlaylistInput.length > 0) {
          currentPlaylist = currentPlaylist.filter((p) => {
            const search = this.searchPlaylistInput.toLowerCase();
            let bool = p.name.toLowerCase().includes(search);
            return bool;
          });
        }
        return currentPlaylist;
      } else {
        if (this.sortPlaylistBy == 'Oldest first') {
          this.sortPlaylistTrigger = false;
          currentPlaylist = currentPlaylist.reverse();
          return currentPlaylist;
        }
        if (this.sortPlaylistBy == 'Newest first') {
          this.sortPlaylistTrigger = false;
          return currentPlaylist;
        }
      }
    },
    hasHlsLink() {
      if (this.$store.state.User && this.$store.state.User.hlsForVod) {
        return true
      } else return false
    },
    getEpisodeIframeSnippet() {
      if (this.features.responsive.status) {
        return `<iframe src="https://player.castr.com/playlist/${this.playlist && this.playlist[this.playlistIndex]?._id}${this.query}" width="100%" style="aspect-ratio: 16/9; min-height: 340px;" frameborder="0" scrolling="auto" allow="autoplay" allowfullscreen  webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen></iframe>`
      } else {
        return `<iframe src="https://player.castr.com/playlist/${this.playlist && this.playlist[this.playlistIndex]?._id}${this.query}" width="590" height="431" frameborder="0" scrolling="auto" allow="autoplay" allowfullscreen webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen></iframe>`
      }
    },
    query() {
      let loop = ''
      let autoPlayNext = ''
      let shuffle = '';
      this.features.loop.status ? loop = '&loop=on' : loop = ''
      this.features.autoPlayNext.status ? autoPlayNext = '&autoPlayNext=true' : autoPlayNext = ''
      this.features.shuffle.status ? shuffle = '&shuffle=true' : shuffle = ''

      let queryString = loop + autoPlayNext + shuffle;
      if (queryString.length) {
        queryString = '?' + queryString.substring(1)
      }
      return queryString
    }
  },
  async mounted() {
    draggable.compatConfig = { MODE: 3 }
    this.$store.dispatch('Ui/setLoadingStatus', true)
    await this.$store.dispatch('Playlist/getPlaylist')
    await this.$store.dispatch('Streams/getStreams');
    await this.$store.dispatch('User/loadUser');
    if (this.playlist.length > 0) {
      this.hasPlaylist = true
      let playlistStreams = this.playlistCopy[this.playlistIndex].streams
      this.playlistName = this.playlistCopy[this.playlistIndex].name
      this.setupPlaylistSettings();
      if (playlistStreams.length > 0) {
        this.streamsModal = [...playlistStreams];
        this.streamsModal = this.streamsModal.filter((s) => {
          let exists = true;
          if (s.type == 'live') {
            exists = this.allInOneStreams.some(el => el._id === s.id);
          }
          if (!exists) {
            this.removeItem(s);
          }
          return exists;
        });
      }
    } else {
      this.hasPlaylist = false
    }
    if ((this.playlistCopy.length > 0) && this.playlistIndex == 0) {
      this.$router.push({ path: '/playlists/' + this.playlistCopy[this.playlistIndex]._id }).catch(() => { });
    }
    setTimeout(() => {
      this.$store.dispatch('Ui/setLoadingStatus', false)
    }, 2000);
  },
  methods: {
    createdPlaylist() {
      this.hasPlaylist = true;
      this.selectPlaylist(0);
    },
    async getVodFiles(vodId) {
      this.$root.$emit('bv::toggle::collapse', 'folder' + vodId)
      this.loading = true
      await this.$store.dispatch('Streams/getVodFilesByVodId', vodId)
      this.loading = false
    },
    startDrag(evt, item) {
      evt.dataTransfer.dropEffect = 'move'
      evt.dataTransfer.effectAllowed = 'move'
      var stream = JSON.stringify(item);
      evt.dataTransfer.setData('item', stream)
    },
    selectPlaylist(index) {
      this.playlistIndex = index;
      this.resStep = 2;
      let playlistStreams = this.playlistCopy[index].streams
      this.playlistName = this.playlistCopy[index].name
      this.streamsModal = [];
      if (playlistStreams.length > 0) {
        this.streamsModal = [...playlistStreams];
      }
      this.$router.push({ path: '/playlists/' + this.playlistCopy[index]._id }).catch(() => { });
      this.resPlaylist = false;
      this.setupPlaylistSettings(true);
    },
    changeRouteQuery(item) {
      if (this.$route.query.tab != item) {
        this.$router.replace({ query: { ...this.$route.query, tab: item } })
      } else return
    },
    remove(i) {
      this.uploadList.splice(i, 1);
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains('drop-zone-hidden_dragover')) {
        event.currentTarget.classList.remove('drop-zone-hidden_dragleave');
        event.currentTarget.classList.add('drop-zone-hidden_dragover');
      }
      if (event.currentTarget.classList.contains('w-100')) {
        event.currentTarget.classList.add('z-10');
      }
    },
    dragleave(event) {
      event.currentTarget.classList.remove('drop-zone-hidden_dragover');
      if (event.currentTarget.classList.contains('w-100')) {
        event.currentTarget.classList.remove('z-10');
      }
    },
    drop(event, list) {
      event.preventDefault();
      console.log('received');
      this.onChange(event);
      event.currentTarget.classList.add('drop-zone-hidden_dragleave');
      event.currentTarget.classList.remove('drop-zone-hidden_dragover');
    },
    dragged() {
      console.log('dragged');
    },
    async onChange(event, selectedStream = null) {
      console.log('open drop');
      if (selectedStream || event.dataTransfer.getData("item")) {
        let stream = {};
        if (selectedStream == null) {
          stream = JSON.parse(event.dataTransfer.getData("item"));
        } else {
          stream = selectedStream;
        }
        if ((stream.type != 'live') && !stream.refId) {
          stream._id = stream.id
        }
        if ((stream.type != 'live') && stream.refId) {
          stream._id = stream.refId
        }
        let streamExists = this.streamsModal.some(el => el.id === stream._id);
        let streamName = '';
        let streamType = '';
        let streamId = '';
        let isLivetovod = false;
        if (stream.type == 'live') {
          streamId = stream._id
          streamName = stream.name
          streamType = 'live';
        } else {
          streamId = stream.id
          streamName = stream.fileName;
          streamType = 'vod';
        }
        if (stream.refId) {
          streamId = stream.refId
          isLivetovod = true;
        }
        let streamArray =
        {
          "id": streamId,
          "type": streamType,
          "isLiveToVod": isLivetovod,
          "name": streamName
        }
        console.log(streamArray);
        console.log(this.streamsModal);
        if (!streamExists) {
          this.streamsModal.unshift(streamArray);
          await this.addToplaylist(this.streamsModal, !(selectedStream == null))
        } else {
          this.$notify({ group: 'error', text: 'You already have this item in your playlist.' })
        }
        console.log(streamArray);
        console.log(this.streamsModal);
      }
    },
    async addToplaylist(streamArray, back = false) {
      let currentPlaylist = this.playlist[this.playlistIndex];
      const playlist = await PlaylistService.updatePlaylist(currentPlaylist.name, streamArray, currentPlaylist._id);
      this.streamsModal = playlist.streams
      await this.$store.dispatch('Playlist/getPlaylist')
      if (back) {
        this.resStep = 2;
      }
    },
    async removePlaylist(index = null) {
      this.currentIndexed = index;
      this.$root.$emit("bv::show::modal", 'delete-playlist');
    },
    async removePlaylists(index = null) {

      if (this.playlist) {
        this.$store.dispatch('Ui/setLoadingStatus', true)
        let currentIndex = '';
        if (index) {
          currentIndex = index
        } else {
          currentIndex = this.playlistIndex
        }
        let pid = this.playlistCopy[currentIndex]?._id;
        let pname = this.playlistCopy[currentIndex]?.name;
        const playlist = await PlaylistService.deletePlaylist(pid)
        this.$notify({
          group: 'success',
          text: `Playlist "${pname}" is completely deleted from your account`,
        })
        await this.$store.dispatch('Playlist/getPlaylist')
        this.sortPlaylistBy = 'Oldest first'
        let newIndex = currentIndex - 1
        if (newIndex < 0) newIndex = 0
        if (this.playlist.length > 0) {
          this.selectPlaylist(newIndex);
          this.hasPlaylist = true
        } else {
          this.hasPlaylist = false
        }
        this.resStep = 1;
        this.$store.dispatch('Ui/setLoadingStatus', false)

      }
    },
    async playlistToggle(index = null) {
      if (this.playlist) {
        let pid = this.playlistCopy[this.playlistIndex]?._id;
        let shouldDisabled = false;
        if (index) {
          shouldDisabled = this.playlistCopy[index].disabled;
        } else {
          shouldDisabled = this.playlistCopy[this.playlistIndex]?.disabled;
        }
        const playlist = await PlaylistService.playlistToggle(pid, !shouldDisabled)
        await this.$store.dispatch('Playlist/getPlaylist')
        if (shouldDisabled) {
          this.$notify({ group: 'success', text: 'Your playlist is Enabled' })
        } else {
          this.$notify({ group: 'success', text: 'Your playlist is Disabled' })
        }
      }
    },
    async changeName() {
      if (this.playlist) {
        let pid = this.playlistCopy[this.playlistIndex]?._id;
        let pname = this.playlistCopy[this.playlistIndex]?.name;
        let newname = this.playlistName;
        if (this.playlist?.length > 0) {
          const bool = this.playlist.filter((s) => {
            return s.name == this.playlistName
          });
          this.exists = bool;
        }
        if (this.exists.length > 0) {
          this.$notify({ group: 'error', text: `"${this.playlistName}" Playlist exists.` })
          this.playlistName = pname
        } else {
          const playlist = await PlaylistService.nameChange(pid, newname)
          await this.$store.dispatch('Playlist/getPlaylist')
        }
      }
    },
    log(msg, event) {
      console.log(event.target.tagName, msg);
    },
    backOnestep() {
      this.resStep = 2;
    },
    changedOrder(streams) {
      this.addToplaylist(streams);
    },
    changeSortBy(option, type) {
      this.sortBy = option;
      this.$store.dispatch('Streams/sortStreams', this.sortBy)
    },
    back() {
      this.resStep = 1;
    },
    changePlaylistSortBy(option) {
      this.sortPlaylistBy = option;
      this.sortPlaylistTrigger = true;
    },
    onSearchWidgetFocus() {
      this.searchWidgetFocused = true;
    },
    onSearchWidgetBlur() {
      this.searchWidgetFocused = false;
      setTimeout(() => {
        const blankSearchVal =
          !this.searchLiveInput || !this.searchLiveInput.length;
        if (
          this.searchWidgetActive &&
          blankSearchVal &&
          !this.searchWidgetFocused
        ) {
          this.toggleSearchWidget();
        }
      }, 500);
    },
    onPlaylistSearchWidgetFocus() {
      this.searchPlaylistWidgetFocused = true;
    },
    onPlaylistSearchWidgetBlur() {
      this.searchPlaylistWidgetFocused = false;
      setTimeout(() => {
        const blankSearchVal =
          !this.searchPlaylistInput || !this.searchPlaylistInput.length;
        if (
          this.searchPlaylistWidgetActive &&
          blankSearchVal &&
          !this.searchPlaylistWidgetFocused
        ) {
          this.togglePlaylistSearchWidget();
        }
      }, 500);
    },
    showPlaylist() {
      this.resPlaylist = !this.resPlaylist
    },
    toggleSearchWidget() {
      this.searchWidgetActive = !this.searchWidgetActive;
      this.$refs.searchLive.focus();
      if (!this.searchWidgetActive) {
        this.searchLiveInput = '';
      }
    },
    togglePlaylistSearchWidget() {
      this.searchPlaylistWidgetActive = !this.searchPlaylistWidgetActive;
      this.$refs.searchPlaylist.focus();
      if (!this.searchPlaylistWidgetActive) {
        this.searchPlaylistInput = '';
      }
    },
    async toggleFeature(featureName) {
      if (featureName === 'responsive' || featureName === 'audioOnly' || featureName === 'loop' || featureName === 'muted' || featureName === 'hiddenControl' || featureName === 'hiddenVolume') {
        this.featureProcessing[featureName] = !this.featureProcessing[featureName]
      }

      if(['socialSharingEnabled', 
          'shareFacebook',
          'shareTwitter',
          'shareLinkedIn',
          'shareReddit',
          'shareEmail',
          'shareWhatsApp'].includes(featureName)) {

          this.updateSettingsDebounced();
      }
    },
    async updateSettingsDebounced() {
      const newSettings = {...this.playlistSettings, ...this.features };
      let pid = this.playlistCopy[this.playlistIndex]?._id;
      if(pid) await PlaylistService.updateSettings(pid, newSettings);
    },
    async setupPlaylistSettings(shouldReset = false) {
      if(shouldReset) {
        await this.$store.dispatch('Playlist/getPlaylist')
        this.playlistSettings = {};
        this.socialSharingEnabled = false;
        this.features = featuresDefault;
      }
      if(this.playlistCopy[this.playlistIndex].settings) {
        this.playlistSettings = this.playlistCopy[this.playlistIndex]?.settings;
        if(this.playlistSettings) {
          this.features = {...this.features, ..._.cloneDeep(this.playlistSettings)}
          this.socialSharingEnabled = this.features.socialSharingEnabled.status;
        } else {
          this.playlistSettings = {};
        }
      }
    },
    onUpdateSecurity(payload) {
      const { key, value } = payload;
      this.features[key] = value;
      this.updateSettingsDebounced();
    },
    getPlayerUrl() {
      let playerUri = 'https://player.castr.com/playlist/' + (this.playlist && this.playlist[this.playlistIndex]?._id) + this.query;
      return playerUri;
    },
    clipboardCopy(text) {
      try {
        if (text instanceof Function) text = text();

        this.$copyText(text);
        this.$notify({ group: 'info', text: 'Copied to clipboard' });
      } catch (e) { }
    },
    removeItem(stream) {
      const streamArray = this.streamsModal.filter((s) => {
        return s.id != stream.id;
      });
      this.addToplaylist(streamArray);
    },
    openStreamslist() {
      this.resStep = 3;
    },
    handleDragging(e) {
			e.preventDefault();
			const position = e.pageX
			const wrapper = document.getElementById('resizible-wrapper')
			const windowWidth = window.innerWidth
      const percentage = ((position - 260) / wrapper.offsetWidth) * 100
      if (percentage >= 20 && percentage <= 30) {
        this.dividerPosition = percentage.toFixed(2)
      }
			if (position - 260 <= 0) {
				document.removeEventListener('mousemove', this.handleDragging)
			}
    },
    startDragging() {
      console.log('eeee');
      document.addEventListener('mousemove', this.handleDragging)
    },
    endDragging() {
      document.removeEventListener('mousemove', this.handleDragging)
		},
    async onSocialSharingToggle() {
      this.socialSharingEnabled = !this.socialSharingEnabled;
      this.features.socialSharingEnabled.status = this.socialSharingEnabled;
      let pid = this.playlistCopy[this.playlistIndex]?._id;
      if(pid) {
        const newSettings = {...this.playlistSettings, ...this.features };
        await PlaylistService.updateSettings(pid, newSettings);
      }
    },
  },
  watch: {
    searchLiveInput() {
      this.$store.dispatch('Streams/searchLive', this.searchLiveInput)
    },
    searchPlaylistInput() {
      this.playlistCopy;
    }
  },
  data() {
    return {
      playlistSettings: {},
      playlistIndex: 0,
      hasPlaylist: false,
      resStep: 1,
      allowMultipleUploads: true,
      currentIndexed: null,
      streamsModal: [],
      exists: [],
      sortBy: "Newest first",
      sortPlaylistBy: "Newest first",
      searchLiveInput: '',
      searchPlaylistInput: '',
      playlistName: '',
      searchVodInput: '',
      searchWidgetFocused: false,
      sortPlaylistTrigger: false,
      searchWidgetActive: false,
      searchPlaylistWidgetFocused: false,
      searchPlaylistWidgetActive: false,
      loading: false,
      resPlaylist: false,
      features: {
        embedAutoplay: {
          status: false,
        },
        responsive: {
          status: true,
        },
        loop: {
          status: false,
        },
        shuffle: {
          status: false,
        },
        autoPlayNext: {
          status: false,
        },
        socialSharingEnabled: {
          status: false,
        },
        shareFacebook: {
					status: true,
				},
				shareTwitter: {
					status: true,
				},
				shareLinkedIn: {
					status: false
				},
				shareReddit: {
					status: false
				},
				shareEmail: {
					status: false
				},
				shareWhatsApp: {
					status: false
				},
        countryBlock: {
          enabled: false,
          value: [],
          valueType: 'array'
        },
        countryWhitelists: {
          enabled: false,
          value: [],
          valueType: 'array'
        },
        domainWhitelists: {
          enabled: false,
          value: [],
          valueType: 'array'
        }
      },
      socialSharingEnabled: false, 
      featureProcessing: {
        responsive: false,
        embedAutoplay: false,
        autoPlayNext: false,
        loop: false,
        shuffle: false,
        shareFacebook: false,
				shareTwitter: false,
				shareLinkedIn: false,
				shareReddit: false,
				shareEmail: false,
				shareWhatsApp: false,
      },
      dividerPosition: 25
    };
  },
};
</script>

<style scoped>
.playlist_left li {
  border-radius: 6px;
  cursor: pointer;
}

.playlist_left li:hover {
  background-color: rgba(167, 181, 226, 0.08);
}

.playlist_left {
  padding: 0px 12px;
  width: 22.5%;
  padding-top: 28px;
  border-right: 1px solid rgba(167, 181, 226, 0.08)
}

.playlist_right {
  width: 77.5%;
  padding-top: 24px;
  padding-left: 8.4%;
  padding-right: 8.4%;
}

.playlist-item>div {
  margin-bottom: 22px;
}

.playlist-item {
  width: 54%;
}

.all-streams .drop-zone-circle {
  width: 386px;
  height: 400px;
  border-radius: 6px !important;
  border: 1px dashed var(--neutral-03, rgba(161, 178, 232, 0.14));
  overflow: scroll;
  scrollbar-width: none;
}

.all-streams .drop-zone-circle::-webkit-scrollbar {
  width: 2px;
}

.all-streams .drop-zone-circle::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px var(--c-dark-1);
}

.all-streams .drop-zone-circle::-webkit-scrollbar-thumb {
  background-color: rgba(167, 181, 226, 0.08);
  outline: 1px;
}

.all-streams .tabs {
  border-radius: 8px;
  border: 1px solid var(--neutral-02, rgba(167, 181, 226, 0.08));
  background: var(--neutral-02, rgba(167, 181, 226, 0.08));
  margin-left: 24px;
  width: 300px;
  padding: 8px 16px 4px 16px;
  max-height: 500px;
  height: 466px;
  overflow: scroll;
  scrollbar-width: none;
}

.playlist-top-control {
  display: flex;
}

.playlist-source li:not(:nth-child(2)):hover {
  background: var(--neutral-04, rgba(167, 181, 226, 0.25));
  border-radius: 8px;
}

.playlist-source ul {
  padding: 0px;
}

.playlist-source li:first-child {
  margin-top: 12px;
  background: transparent;
  border-bottom: 0px;
  position: relative;
  padding: 0;
  margin-bottom: 10px;
}

.playlist-source li,
.playlist li {
  padding: 12px 8px 12px 0px;
  cursor: pointer;
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid rgba(161, 178, 232, 0.14);
  position: relative;
}

.search_icon {
  position: absolute;
  left: 10px;
}

.liveSearchfield {
  padding-left: 28px;
}

svg.included {
  position: absolute;
  top: 15px;
  right: 0;
}

.playlist-container+.footer {
  display: none !important;
}

.all-streams .tabs::-webkit-scrollbar {
  width: 2px;
}

.all-streams .tabs::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(167, 181, 226, 0.08);
}

.all-streams .tabs::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  outline: 1px;
}

.all-streams {
  max-width: 100%;
}

.playlist-container .page-title {
  padding-left: 110px;
  font-size: 20px;
  font-weight: 500;
}

.single-file {
  position: relative;
}

.single-file svg.included {
  top: 15px;
}

.res-block,
.res-flex {
  display: none !important;
}

.playlisSearch {
  padding: 4px 12px;
  padding-left: 40px !important;
}

.lists .search_icon {
  left: 12px;
  top: 10px;
}

.fa-chevron-down.pl:before {
  display: none;
}

.playlist_sort .dropdown,
.playlist_sort button {
  display: block;
  width: 100%;
}

.playlist-item input {
  background: var(--c-dark-1);
  border: 0px;
}

.playlist-item input:focus {
  background: var(--c-dark-3);
}

.playlist_left .dropdown-menu li {
  background: transparent;
  padding: 0 !important;
  border-radius: 0 !important;
}

.all-streams .single-file {
  border-top: 1px solid rgba(161, 178, 232, 0.14) !important;
}

.playlist-source li div.show {
  margin-bottom: -10px;
}

.playlist_vod_tab li:hover {
  background: transparent !important;
}

.playlist_left li.active {
  background: rgba(167, 181, 226, 0.08);
}

.empty_tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center !important;
  min-height: 287px;
  border: 0px !important;
}

.playlist_left li>span {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 90%;
  white-space: nowrap;
}

@media only screen and (max-width: 768px) {

  .playlist_info,
  .playlist-item,
  .all-streams .tabs,
  .playlist_right {
    display: none;
  }

  .playlist_left {
    width: 100%;
  }

  .res-block {
    display: inline-block !important;
  }

  .res-flex {
    display: inline-flex !important;
  }

  .desk-block {
    display: none !important;
  }

  .playlist_left li {
    flex-wrap: wrap;
    background: rgba(167, 181, 226, 0.08);
    padding: 12px 16px 16px 16px !important;
    border-radius: 8px;
    margin-bottom: 16px;
  }

  .playlist_left li>span {
    display: block;
    width: 100%;
  }

  .playlist_left li>span:first-child {
    font-size: 17px;
    font-weight: 500 !important;
    color: #fff;
  }

  .playlist_header h2 {
    font-size: 22px;
  }

  .playlist_header {
    padding: 0px !important;
  }

  .playlist_left:not(.first-step) {
    display: none;
  }

  .playlist_right.second-step {
    display: block;
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
  }

  .second-step .playlist-item {
    display: block;
    width: 100%;
  }

  .all-streams {
    flex-wrap: wrap;
  }

  .all-streams .tabs.second-step {
    /* display: block; */
  }

  .playlist_info.w-100.second-step {
    display: block;
  }

  .all-streams .drop-zone-circle {
    width: 100%;
    height: unset;
  }

  .all-streams {
    width: 100%;
  }

  .playlist ul {
    margin-bottom: 0;
  }

  .playlist_info ul {
    display: none;
  }

  .playlist_info .list-group-item {
    width: 50%;
    padding-top: 5px;
    padding-bottom: 6px;
  }

  .playlist_info .list-group {
    flex-wrap: wrap;
  }

  .custom-switch.b-custom-control-sm .custom-control-label::before {}

  .playlist_info .list-group-item:last-child {
    transform: translateX(8px);
  }

  .playlist_info textarea {
    height: 156px;
  }

  .all-streams .drop-zone-circle {
    border: 0px;
  }

  .playlist-container .page-title {
    padding-left: 15px !important;
    text-align: center;
  }

  .all-streams .tabs.third-step {
    position: fixed;
    display: block !important;
    margin-left: 0px !important;
    width: 100%;
    background: var(--c-dark-1);
    border-radius: 0;
    border: 0;
    top: 0;
    left: 0;
    z-index: 99999;
    padding: 0;
    max-height: unset;
    height: 100%;
  }

  .playlist_right.third-step {
    display: block;
    width: 100%;
    padding-left: 0%;
    padding-right: 0%;
  }

  .tab-close.res-block {
    background: var(--label-05, rgba(173, 184, 220, 0.50));
    border-radius: 100%;
    width: 32px;
    height: 32px;
    display: flex;
    text-align: center;
    cursor: pointer;
    position: absolute;
    z-index: 999999;
    top: 10px;
    right: 16px;
  }

  .tab-close.res-block svg {
    margin-top: 5px;
  }

  .playlist-source li {
    padding-right: 0;
  }

  .single-stream span {
    display: inline-block;
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1;
  }

  .single-stream {
    display: flex;
    align-items: center;
  }

  .addPlaylist_btn {
    transform: translateY(-20px);
  }

  .single-file span {
    display: block;
    max-width: 130px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .playlist-top-control {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .res-playlist .playlist_left {
    display: block !important;
    position: absolute;
    top: 150px;
    left: 5%;
    width: 90%;
    z-index: 9999;
    background: var(--c-dark-3);
    border-radius: 6px;
    padding-top: 0px;
  }

  .res-playlist .playlist_header,
  .res-playlist .lists>.res-block,
  .res-playlist .res-control {
    display: none !important;
  }


  .res-playlist ul.list-group li span:not(:first-child) {
    display: none !important;
  }

  .res-playlist .playlist_left li {
    background: transparent !important;
    padding: 8px 0px !important;
    border-bottom: 1px solid var(--c-dark-4) !important;
    border-radius: 0px;
    margin-bottom: 0px !important;
  }
}
.modal-open .toggle-hide {
 display: none;
}
</style>